// propertyData.jsx

export const propertyData = {
  // ... your existing properties here ...

  // CORRECTED PROPERTIES WITH ACCURATE DATA

  'symphony-meydan-horizon': {
    title: 'The Symphony by Imtiaz',
    location: 'Meydan Horizon, Dubai, UAE',
    type: '1, 2 & 3BR Apartments & Penthouses',
    builder: 'Imtiaz Developments',
    floors: '40-Storey Tower',
    category: 'Residential',
    bedrooms: '1-3 BR + Penthouses',
    bathrooms: '1-4',
    area: '650-4,244 sq.ft',
    isFeatured: true,
    isLuxury: true,
    mapUrl: 'https://maps.app.goo.gl/YOUR_MAP_LINK_HERE',
    description: 'The Symphony by Imtiaz is an architectural masterpiece designed in collaboration with Zaha Hadid Architects. This AED 1 billion development features fluid, sculptural design inspired by UAE traditional crafts, offering ultra-luxury residences with crystal lagoon views and proximity to Ras Al Khor Wildlife Sanctuary.',
    ellingtonPricing: {
      startingPrice: {
        aed: 2000000
      },
      paymentPlan: '60/40 Payment Plan',
      highlights: 'Zaha Hadid Architects designed ultra-luxury'
    },
    specialFeatures: [
      'Starting from AED 2M',
      '60/40 Payment Plan',
      'Designed by Zaha Hadid Architects',
      'Crystal lagoon frontage',
      'Ras Al Khor Sanctuary views',
      '40-storey iconic tower',
      'Smart home technology',
      'Over 25 luxury amenities',
      'Completion Q2 2029'
    ],
    features: [
      { icon: 'FaCrown', text: 'Zaha Hadid Design' },
      { icon: 'FaSwimmingPool', text: 'Infinity Pool' },
      { icon: 'FaDumbbell', text: 'Premium Fitness Center' },
      { icon: 'FaSpa', text: 'Spa & Sauna' },
      { icon: 'FaCouch', text: 'Rooftop Lounge' },
      { icon: 'FaChild', text: 'Kids Play Area' },
      { icon: 'FaBriefcase', text: 'Co-working Lounge' },
      { icon: 'FaFilm', text: 'Outdoor Cinema' },
      { icon: 'FaTree', text: 'Jogging Track' },
      { icon: 'FaFire', text: 'BBQ Area' },
      { icon: 'FaHome', text: 'Smart Home Tech' },
      { icon: 'FaCar', text: 'Covered Parking' },
      { icon: 'FaShieldAlt', text: '24/7 Security' }
    ],
    contact: {
      name: 'Sales Team',
      position: 'Luxury Property Consultant',
      company: 'Imtiaz Developments',
      phone: '+971XXXXXXXXX',
      email: 'sales@imtiaz.ae'
    },
    media: [
      {
        type: 'video',
        src: '/assets/residential/imtiaz/symphony-meydan.mp4',
        poster: '/assets/residential/imtiaz/symphony-meydan.jpg'
      },
      {
        type: 'image',
        src: '/assets/residential/imtiaz/symphony-meydan1.jpg'
      },
      {
        type: 'image',
        src: '/assets/residential/imtiaz/symphony-meydan2.jpg'
      },
      {
        type: 'image',
        src: '/assets/residential/imtiaz/symphony-meydan3.jpg'
      },
      {
        type: 'image',
        src: '/assets/residential/imtiaz/symphony-meydan4.jpg'
      },
      {
        type: 'image',
        src: '/assets/residential/imtiaz/symphony-meydan5.jpg'
      },
      {
        type: 'image',
        src: '/assets/residential/imtiaz/symphony-meydan6.jpg'
      }
    ]
  },

  'danube-elitz-3-al-furjan': {
    title: 'Danube Elitz 3',
    location: 'Al Furjan, Dubai, UAE',
    type: 'Studios, 1 & 2BR Apartments',
    builder: 'Danube Properties',
    floors: 'High-Rise',
    category: 'Residential',
    bedrooms: 'Studio-2 BR',
    bathrooms: '1-2',
    area: '420-891 sq.ft',
    isFeatured: true,
    description: 'Danube Elitz 3 offers affordable luxury living in Al Furjan with studios to 2-bedroom apartments. This popular development features modern design, premium amenities, and excellent payment plans.',
    ellingtonPricing: {
      startingPrice: {
        aed: 765000
      },
      paymentPlan: '1% Monthly Payment Plan',
      highlights: 'Affordable luxury with easy payment plans'
    },
    specialFeatures: [
      'Starting from AED 765K',
      '1% Monthly Payment Plan',
      'Al Furjan location',
      'Studios to 2BR',
      'Modern amenities',
      'Service charge AED 13/sqft',
      'Completion Nov 2026'
    ],
    features: [
      { icon: 'FaHome', text: 'Affordable Luxury' },
      { icon: 'FaSwimmingPool', text: 'Swimming Pool' },
      { icon: 'FaDumbbell', text: 'Fitness Center' },
      { icon: 'FaCar', text: 'Covered Parking' },
      { icon: 'FaShieldAlt', text: '24/7 Security' },
      { icon: 'FaChild', text: 'Kids Play Area' },
      { icon: 'FaStar', text: 'Easy Payment Plan' }
    ],
    contact: {
      name: 'Sales Team',
      position: 'Property Consultant',
      company: 'Danube Properties',
      phone: '+971XXXXXXXXX',
      email: 'sales@danubeproperties.com'
    },
    media: [
      {
        type: 'video',
        src: '/assets/residential/danube/danube-elitz-3-video.mp4',
        poster: '/assets/residential/danube/danube-elitz-3.jpg'
      },
      {
        type: 'image',
        src: '/assets/residential/danube/danube-elitz-3.jpg'
      },
      {
        type: 'image',
        src: '/assets/residential/danube/danube-elitz-3-1.jpg'
      },
      {
        type: 'image',
        src: '/assets/residential/danube/danube-elitz-3-2.jpg'
      },
      {
        type: 'image',
        src: '/assets/residential/danube/danube-elitz-3-3.jpg'
      },
      {
        type: 'image',
        src: '/assets/residential/danube/danube-elitz-3-4.jpg'
      },
      {
        type: 'image',
        src: '/assets/residential/danube/danube-elitz-3-5.jpg'
      }
    ]
  },

  'peace-homes-town-square': {
    title: 'Peace Lagoons',
    location: 'Dubailand Residence Complex, Dubai, UAE',
    type: 'Studio, 1 & 2BR Apartments',
    builder: 'Peace Homes Development',
    floors: 'Mid-Rise',
    category: 'Residential',
    bedrooms: 'Studio-2 BR',
    bathrooms: '1-2',
    area: '410-1,374 sq.ft',
    isFeatured: false,
    description: 'Peace Lagoons offers family-friendly apartments with modern amenities, lagoon access, and community facilities. This development provides quality living in a vibrant community setting with volleyball courts, meditation areas, and a shopping center.',
    ellingtonPricing: {
      startingPrice: {
        aed: 650000
      },
      paymentPlan: 'Flexible Payment Plan',
      highlights: 'Lagoon-front family community living'
    },
    specialFeatures: [
      'Starting from AED 650K',
      'Flexible Payment Plan',
      'Dubailand location',
      'Lagoon access',
      'Family-friendly',
      'Community amenities',
      'Shopping center',
      'Completion Q4 2026'
    ],
    features: [
      { icon: 'FaHome', text: 'Modern Apartments' },
      { icon: 'FaWater', text: 'Lagoon Access' },
      { icon: 'FaChild', text: 'Family Community' },
      { icon: 'FaSwimmingPool', text: 'Swimming Pool' },
      { icon: 'FaDumbbell', text: 'Fitness Center' },
      { icon: 'FaTree', text: 'Meditation Area' },
      { icon: 'FaShoppingBag', text: 'Shopping Center' },
      { icon: 'FaCar', text: 'Covered Parking' },
      { icon: 'FaShieldAlt', text: '24/7 Security' }
    ],
    contact: {
      name: 'Sales Team',
      position: 'Property Consultant',
      company: 'Peace Homes Development',
      phone: '+971XXXXXXXXX',
      email: 'sales@peacehomes.ae'
    },
    images: [
      '/assets/residential/peace-homes/peace-lagoons.jpg',
      '/assets/residential/peace-homes/peace-lagoons-1.jpg',
      '/assets/residential/peace-homes/peace-lagoons-2.jpg',
      '/assets/residential/peace-homes/peace-lagoons-3.jpg',
      '/assets/residential/peace-homes/peace-lagoons-4.jpg',
      '/assets/residential/peace-homes/peace-lagoons-5.jpg',
    ]
  },

  'jacob-and-co-residences': {
    title: 'Burj Binghatti Jacob & Co Residences',
    location: 'Business Bay, Dubai, UAE',
    type: 'Luxury Branded Residences',
    builder: 'Binghatti & Jacob & Co',
    floors: 'Ultra-Luxury Tower',
    category: 'Residential',
    bedrooms: '2-5 BR',
    bathrooms: '2-5',
    area: 'Ultra-Luxury Tower',
    isFeatured: true,
    isLuxury: true,
    description: 'Burj Binghatti Jacob & Co Residences brings world-renowned luxury jewelry craftsmanship to real estate with ultra-luxury branded residences in Business Bay. Features bespoke interiors and exclusive amenities.',
    ellingtonPricing: {
      startingPrice: {
        aed: 9200000
      },
      paymentPlan: '70/30 Payment Plan',
      highlights: 'Ultra-luxury branded by Jacob & Co'
    },
    specialFeatures: [
      'Starting from AED 9.2M',
      '70/30 Payment Plan',
      'Jacob & Co branded',
      'Ultra-luxury residences',
      'Bespoke interiors',
      'Exclusive amenities',
      'Business Bay',
      'Handover Q2 2026'
    ],
    features: [
      { icon: 'FaCrown', text: 'Ultra Luxury' },
      { icon: 'FaGem', text: 'Branded Residences' },
      { icon: 'FaSwimmingPool', text: 'Luxury Pools' },
      { icon: 'FaSpa', text: 'Exclusive Spa' },
      { icon: 'FaDumbbell', text: 'Premium Gym' },
      { icon: 'FaCar', text: 'Valet Service' },
      { icon: 'FaShieldAlt', text: 'Concierge 24/7' },
      { icon: 'FaBuilding', text: 'Iconic Tower' }
    ],
    contact: {
      name: 'Luxury Sales Team',
      position: 'Luxury Specialist',
      company: 'Binghatti Developers',
      phone: '+971XXXXXXXXX',
      email: 'luxury@binghatti.com'
    },
    media: [
      {
        type: 'video',
        src: '/assets/residential/jacob-co/jacob-co-residences-video.mp4',
        poster: '/assets/residential/jacob-co/jacob-co-residences.jpg'
      },
      {
        type: 'image',
        src: '/assets/residential/jacob-co/jacob-co-residences.jpg'
      },
      {
        type: 'image',
        src: '/assets/residential/jacob-co/jacob-co-1.jpg'
      },
      {
        type: 'image',
        src: '/assets/residential/jacob-co/jacob-co-2.jpg'
      },
      {
        type: 'image',
        src: '/assets/residential/jacob-co/jacob-co-3.jpg'
      },
      {
        type: 'image',
        src: '/assets/residential/jacob-co/jacob-co-4.jpg'
      },
      {
        type: 'image',
        src: '/assets/residential/jacob-co/jacob-co-5.jpg'
      }
    ]
  },

  'samana-park-views-arjan': {
    title: 'Samana Park Views',
    location: 'Arjan, Dubai, UAE',
    type: 'Studios, 1 & 2BR Apartments',
    builder: 'Samana Developers',
    floors: 'Mid-Rise',
    category: 'Residential',
    bedrooms: 'Studio-2 BR',
    bathrooms: '1-2',
    area: 'Multiple Units',
    isFeatured: false,
    description: 'Samana Park Views offers affordable apartments in Arjan with modern design and amenities. This popular development features flexible payment plans and excellent connectivity.',
    ellingtonPricing: {
      startingPrice: {
        aed: 780000
      },
      paymentPlan: 'Flexible Payment Plan',
      highlights: 'Affordable entry in Arjan'
    },
    specialFeatures: [
      'Starting from AED 780K',
      'Flexible Payment Plan',
      'Arjan location',
      'Studios to 2BR',
      'Avg price AED 13,515/sqm',
      'Modern amenities',
      'Completion 2026'
    ],
    features: [
      { icon: 'FaHome', text: 'Affordable Entry' },
      { icon: 'FaSwimmingPool', text: 'Swimming Pool' },
      { icon: 'FaDumbbell', text: 'Fitness Center' },
      { icon: 'FaCar', text: 'Covered Parking' },
      { icon: 'FaShieldAlt', text: '24/7 Security' },
      { icon: 'FaTree', text: 'Park Views' },
      { icon: 'FaStar', text: 'Great Value' }
    ],
    contact: {
      name: 'Sales Team',
      position: 'Property Consultant',
      company: 'Samana Developers',
      phone: '+971XXXXXXXXX',
      email: 'sales@samana.ae'
    },
    media: [
      {
        type: 'video',
        src: '/assets/residential/samana/samana-park-views-video.mp4',
        poster: '/assets/residential/samana/samana-park-views.jpg'
      },
      {
        type: 'image',
        src: '/assets/residential/samana/samana-park-views.jpg'
      },
      {
        type: 'image',
        src: '/assets/residential/samana/samana-1.jpg'
      },
      {
        type: 'image',
        src: '/assets/residential/samana/samana-2.jpg'
      },
      {
        type: 'image',
        src: '/assets/residential/samana/samana-3.jpg'
      },
      {
        type: 'image',
        src: '/assets/residential/samana/samana-4.jpg'
      },
      {
        type: 'image',
        src: '/assets/residential/samana/samana-5.jpg'
      }
    ]
  },

  'one-broker-heights-jvc': {
    title: 'One Broker Heights',
    location: 'JVC, Dubai, UAE',
    type: 'Studio, 1 & 2BR Apartments',
    builder: 'One Broker Group',
    floors: 'Mid-Rise',
    category: 'Residential',
    bedrooms: 'Studio-2 BR',
    bathrooms: '1-2',
    area: '405-900 sq.ft',
    isFeatured: false,
    description: 'One Broker Heights in JVC offers well-designed studio to 2-bedroom apartments with modern amenities and community facilities. Perfect for families and investors.',
    ellingtonPricing: {
      startingPrice: {
        aed: 680000
      },
      paymentPlan: 'Flexible Payment Plan',
      highlights: 'Affordable JVC living'
    },
    specialFeatures: [
      'Starting from AED 680K',
      'Flexible Payment Plan',
      'JVC location',
      'Studio to 2 bedroom apartments',
      'Community amenities',
      'Family-friendly',
      'Completion 2026'
    ],
    features: [
      { icon: 'FaHome', text: 'Modern Design' },
      { icon: 'FaSwimmingPool', text: 'Swimming Pool' },
      { icon: 'FaDumbbell', text: 'Fitness Center' },
      { icon: 'FaCar', text: 'Covered Parking' },
      { icon: 'FaShieldAlt', text: '24/7 Security' },
      { icon: 'FaChild', text: 'Kids Play Area' }
    ],
    contact: {
      name: 'Sales Team',
      position: 'Property Consultant',
      company: 'One Broker Group',
      phone: '+971XXXXXXXXX',
      email: 'sales@onebroker.ae'
    },
    images: [
      '/assets/residential/one-broker/one-broker-heights.jpg',
      '/assets/residential/one-broker/one-broker-1.jpg',
      '/assets/residential/one-broker/one-broker-2.jpg',
      '/assets/residential/one-broker/one-broker-3.jpg',
      '/assets/residential/one-broker/one-broker-4.jpg',
      '/assets/residential/one-broker/one-broker-5.jpg',
    ]
  },

  'difc-living-difc': {
    title: 'DIFC Living',
    location: 'DIFC, Dubai, UAE',
    type: '1, 2 & 3BR Luxury Apartments',
    builder: 'DIFC',
    floors: 'High-Rise',
    category: 'Residential',
    bedrooms: '1-3 BR',
    bathrooms: '1-3',
    area: 'Luxury Tower',
    isFeatured: true,
    description: 'DIFC Living offers luxury apartments in the heart of Dubai\'s financial district with premium amenities and world-class connectivity. Experience sophisticated urban living.',
    ellingtonPricing: {
      startingPrice: {
        aed: 1495000
      },
      paymentPlan: '5% Down, 65% During Construction, 30% On Handover',
      highlights: 'Luxury living in financial district'
    },
    specialFeatures: [
      'Starting from AED 1.495M',
      '5-65-30 Payment Plan',
      'DIFC prime location',
      'Luxury apartments',
      'Premium amenities',
      'Prime connectivity',
      'Completion Q3 2026'
    ],
    features: [
      { icon: 'FaBuilding', text: 'DIFC Location' },
      { icon: 'FaCity', text: 'City Views' },
      { icon: 'FaSwimmingPool', text: 'Luxury Pool' },
      { icon: 'FaDumbbell', text: 'Premium Gym' },
      { icon: 'FaSpa', text: 'Spa & Wellness' },
      { icon: 'FaCar', text: 'Valet Parking' },
      { icon: 'FaShieldAlt', text: 'Concierge Services' }
    ],
    contact: {
      name: 'Luxury Sales Team',
      position: 'Senior Consultant',
      company: 'DIFC',
      phone: '+971XXXXXXXXX',
      email: 'living@difc.ae'
    },
    media: [
      {
        type: 'video',
        src: '/assets/residential/difc/difc-living-video.mp4',
        poster: '/assets/residential/difc/difc-living.jpg'
      },
      {
        type: 'image',
        src: '/assets/residential/difc/difc-living.jpg'
      },
      {
        type: 'image',
        src: '/assets/residential/difc/difc-living-1.jpg'
      },
      {
        type: 'image',
        src: '/assets/residential/difc/difc-living-2.jpg'
      },
      {
        type: 'image',
        src: '/assets/residential/difc/difc-living-3.jpg'
      },
      {
        type: 'image',
        src: '/assets/residential/difc/difc-living-4.jpg'
      },
      {
        type: 'image',
        src: '/assets/residential/difc/difc-living-5.jpg'
      }
    ]
  },

  'damac-lagoons-damac-hills': {
    title: 'DAMAC Lagoons',
    location: 'DAMAC Hills, Dubai, UAE',
    type: '3-7BR Luxury Villas & Townhouses',
    builder: 'DAMAC Properties',
    floors: 'Villa Community',
    category: 'Residential',
    bedrooms: '3-7 BR',
    bathrooms: '3-7',
    area: 'Villa Community',
    isFeatured: true,
    isLuxury: true,
    description: 'DAMAC Lagoons offers luxury waterfront villas and townhouses inspired by global destinations with crystal lagoons, beaches, and world-class amenities. Experience resort-style living in Dubai.',
    ellingtonPricing: {
      startingPrice: {
        aed: 1500000
      },
      paymentPlan: 'Flexible Payment Plan',
      highlights: 'Waterfront villas with crystal lagoons'
    },
    specialFeatures: [
      'Starting from AED 1.5M',
      'Flexible Payment Plan',
      'Crystal lagoons',
      'Private beaches',
      '3-7 bedroom villas',
      'Townhouses from AED 2.7M',
      'Waterfront living',
      'Resort amenities'
    ],
    features: [
      { icon: 'FaHome', text: 'Luxury Villas' },
      { icon: 'FaWater', text: 'Crystal Lagoons' },
      { icon: 'FaUmbrellaBeach', text: 'Private Beach' },
      { icon: 'FaSwimmingPool', text: 'Multiple Pools' },
      { icon: 'FaDumbbell', text: 'Fitness Center' },
      { icon: 'FaCar', text: 'Private Parking' },
      { icon: 'FaShieldAlt', text: 'Gated Security' },
      { icon: 'FaTree', text: 'Green Spaces' }
    ],
    contact: {
      name: 'Villa Sales Team',
      position: 'Villa Specialist',
      company: 'DAMAC Properties',
      phone: '+971XXXXXXXXX',
      email: 'lagoons@damacproperties.com'
    },
    media: [
      {
        type: 'video',
        src: '/assets/residential/damac/damac-lagoons-video.mp4',
        poster: '/assets/residential/damac/damac-lagoons.jpg'
      },
      {
        type: 'image',
        src: '/assets/residential/damac/damac-lagoons.jpg'
      },
      {
        type: 'image',
        src: '/assets/residential/damac/damac-lagoons-1.jpg'
      },
      {
        type: 'image',
        src: '/assets/residential/damac/damac-lagoons-2.jpg'
      },
      {
        type: 'image',
        src: '/assets/residential/damac/damac-lagoons-3.jpg'
      },
      {
        type: 'image',
        src: '/assets/residential/damac/damac-lagoons-4.jpg'
      },
      {
        type: 'image',
        src: '/assets/residential/damac/damac-lagoons-5.jpg'
      }
    ]
  },

  'district-one-meydan': {
    title: 'District One',
    location: 'Meydan, Dubai, UAE',
    type: 'Ultra-Luxury Villas',
    builder: 'Dubai Properties',
    floors: 'Luxury Villa Community',
    category: 'Residential',
    bedrooms: '4-7 BR',
    bathrooms: '4-7',
    area: '6,144-11,096 sq.ft',
    isFeatured: true,
    isLuxury: true,
    description: 'District One is Dubai\'s most exclusive villa community featuring ultra-luxury mansions with private lagoons and beaches. Experience unparalleled luxury living with stunning Burj Khalifa views.',
    ellingtonPricing: {
      startingPrice: {
        aed: 7400000
      },
      paymentPlan: 'Bespoke Payment Plan',
      highlights: 'Ultra-luxury with crystal lagoon'
    },
    specialFeatures: [
      'Starting from AED 7.4M',
      'Bespoke Payment Plans',
      'Ultra-luxury villas',
      '7km crystal lagoon',
      '14km private beach',
      'Burj Khalifa views',
      'Exclusive community',
      'Meydan location'
    ],
    features: [
      { icon: 'FaCrown', text: 'Ultra Luxury' },
      { icon: 'FaHome', text: 'Luxury Mansions' },
      { icon: 'FaWater', text: 'Crystal Lagoon' },
      { icon: 'FaUmbrellaBeach', text: 'Private Beach' },
      { icon: 'FaSwimmingPool', text: 'Private Pools' },
      { icon: 'FaCar', text: 'Multi-Car Garage' },
      { icon: 'FaShieldAlt', text: 'Maximum Security' },
      { icon: 'FaTree', text: 'Lush Landscapes' }
    ],
    contact: {
      name: 'Ultra Luxury Team',
      position: 'Luxury Specialist',
      company: 'Dubai Properties',
      phone: '+971XXXXXXXXX',
      email: 'districtone@dubaiproperties.ae'
    },
    media: [
      {
        type: 'video',
        src: '/assets/residential/dubai-properties/district-one-video.mp4',
        poster: '/assets/residential/dubai-properties/district-one.jpg'
      },
      {
        type: 'image',
        src: '/assets/residential/dubai-properties/district-one.jpg'
      },
      {
        type: 'image',
        src: '/assets/residential/dubai-properties/district-one-1.jpg'
      },
      {
        type: 'image',
        src: '/assets/residential/dubai-properties/district-one-2.jpg'
      },
      {
        type: 'image',
        src: '/assets/residential/dubai-properties/district-one-3.jpg'
      },
      {
        type: 'image',
        src: '/assets/residential/dubai-properties/district-one-4.jpg'
      },
      {
        type: 'image',
        src: '/assets/residential/dubai-properties/district-one-5.jpg'
      }
    ]
  },

  'select-group-grand-bleu': {
    title: 'Grand Bleu Tower',
    location: 'Emaar Beachfront, Dubai, UAE',
    type: '1-4BR Beachfront Apartments & Penthouses',
    builder: 'Emaar Properties (Designed by Elie Saab)',
    floors: 'High-Rise',
    category: 'Residential',
    bedrooms: '1-4 BR',
    bathrooms: '1-4',
    area: '789-3,004 sq.ft',
    isFeatured: true,
    description: 'Grand Bleu Tower offers luxury beachfront living at Emaar Beachfront with stunning sea views and direct beach access. Completed in 2023, this premium tower features Elie Saab designed interiors with world-class amenities.',
    ellingtonPricing: {
      startingPrice: {
        aed: 4000000
      },
      paymentPlan: 'Completed - Ready to Move',
      highlights: 'Luxury beachfront - Ready to Move'
    },
    specialFeatures: [
      'Starting from AED 4M',
      'Completed June 2023',
      'Emaar Beachfront',
      'Elie Saab Design',
      'Direct beach access',
      'Sea views',
      '1-4 bedroom units',
      'Premium amenities',
      'Ready to Move'
    ],
    features: [
      { icon: 'FaUmbrellaBeach', text: 'Beach Access' },
      { icon: 'FaWater', text: 'Sea Views' },
      { icon: 'FaSwimmingPool', text: 'Infinity Pools' },
      { icon: 'FaDumbbell', text: 'Premium Gym' },
      { icon: 'FaSpa', text: 'Spa & Wellness' },
      { icon: 'FaCar', text: 'Valet Parking' },
      { icon: 'FaShieldAlt', text: 'Concierge Services' },
      { icon: 'FaBuilding', text: 'Luxury Tower' }
    ],
    contact: {
      name: 'Beachfront Sales Team',
      position: 'Property Consultant',
      company: 'Emaar Properties',
      phone: '+971XXXXXXXXX',
      email: 'grandbleu@emaar.ae'
    },
    media: [
      {
        type: 'video',
        src: '/assets/residential/emaar/grand-bleu-video.mp4',
        poster: '/assets/residential/emaar/grand-bleu.jpg'
      },
      {
        type: 'image',
        src: '/assets/residential/emaar/grand-bleu.jpg'
      },
      {
        type: 'image',
        src: '/assets/residential/emaar/grand-bleu-1.jpg'
      },
      {
        type: 'image',
        src: '/assets/residential/emaar/grand-bleu-2.jpg'
      },
      {
        type: 'image',
        src: '/assets/residential/emaar/grand-bleu-3.jpg'
      },
      {
        type: 'image',
        src: '/assets/residential/emaar/grand-bleu-4.jpg'
      },
      {
        type: 'image',
        src: '/assets/residential/emaar/grand-bleu-5.jpg'
      }
    ]
  },

  'the-opus-business-bay': {
    title: 'The Opus',
    location: 'Business Bay, Dubai, UAE',
    type: '1-4BR Ultra-Luxury Serviced Residences',
    builder: 'Omniyat (Designed by Zaha Hadid)',
    floors: 'Iconic Tower',
    category: 'Residential',
    bedrooms: '1-4 BR',
    bathrooms: '1-4',
    area: '818-12,788 sq.ft',
    isFeatured: true,
    isLuxury: true,
    description: 'The Opus by Zaha Hadid is an architectural masterpiece offering ultra-luxury serviced residences with ME Dubai hotel services. Experience iconic design with world-class amenities in this completed development.',
    ellingtonPricing: {
      startingPrice: {
        aed: 3957479
      },
      paymentPlan: 'Ready to Move - Completed',
      highlights: 'Zaha Hadid architectural masterpiece'
    },
    specialFeatures: [
      'Starting from AED 3.95M',
      'Completed & Ready',
      'Zaha Hadid design',
      'ME Dubai hotel services',
      'Iconic architecture',
      'Ultra-luxury',
      'Business Bay',
      'Fully furnished'
    ],
    features: [
      { icon: 'FaCrown', text: 'Ultra Luxury' },
      { icon: 'FaBuilding', text: 'Iconic Design' },
      { icon: 'FaHotel', text: 'Hotel Services' },
      { icon: 'FaSwimmingPool', text: 'Luxury Pools' },
      { icon: 'FaSpa', text: 'ME Spa' },
      { icon: 'FaDumbbell', text: 'Premium Gym' },
      { icon: 'FaCar', text: 'Valet Service' },
      { icon: 'FaShieldAlt', text: 'Concierge 24/7' }
    ],
    contact: {
      name: 'Luxury Sales Team',
      position: 'Luxury Specialist',
      company: 'Omniyat',
      phone: '+971XXXXXXXXX',
      email: 'opus@omniyat.com'
    },
    images: [
      '/assets/residential/omniyat/the-opus.jpg',
      '/assets/residential/omniyat/the-opus-1.jpg',
      '/assets/residential/omniyat/the-opus-2.jpg',
      '/assets/residential/omniyat/the-opus-3.jpg',
      '/assets/residential/omniyat/the-opus-4.jpg',
      '/assets/residential/omniyat/the-opus-5.jpg',
    ]
  },

  'deyaar-midtown-dubai-production-city': {
    title: 'Midtown Noor',
    location: 'Dubai Production City, Dubai, UAE',
    type: 'Studios, 1, 2 & 3BR Apartments',
    builder: 'Deyaar Development',
    floors: 'Mid-Rise',
    category: 'Residential',
    bedrooms: 'Studio-3 BR',
    bathrooms: '1-3',
    area: '440-1,800 sq.ft',
    isFeatured: false,
    description: 'Midtown Noor by Deyaar offers affordable apartments in Dubai Production City with modern amenities and excellent connectivity. Completed in 2023, perfect for first-time buyers and investors.',
    ellingtonPricing: {
      startingPrice: {
        aed: 509000
      },
      paymentPlan: 'Zero Down Payment - Monthly from AED 5,000',
      highlights: 'Affordable living in Production City'
    },
    specialFeatures: [
      'Starting from AED 509K',
      'Zero Down Payment',
      'Monthly from AED 5K',
      'Production City',
      'Studios to 3BR',
      'Completed March 2023',
      'Modern amenities',
      'Ready to Move'
    ],
    features: [
      { icon: 'FaHome', text: 'Affordable Entry' },
      { icon: 'FaSwimmingPool', text: 'Swimming Pool' },
      { icon: 'FaDumbbell', text: 'Fitness Center' },
      { icon: 'FaCar', text: 'Covered Parking' },
      { icon: 'FaShieldAlt', text: '24/7 Security' },
      { icon: 'FaChild', text: 'Kids Play Area' },
      { icon: 'FaStar', text: 'Zero Down Payment' }
    ],
    contact: {
      name: 'Sales Team',
      position: 'Property Consultant',
      company: 'Deyaar Development',
      phone: '+971XXXXXXXXX',
      email: 'sales@deyaar.ae'
    },
    images: [
      '/assets/residential/deyaar/midtown.jpg',
      '/assets/residential/deyaar/midtown-1.jpg',
      '/assets/residential/deyaar/midtown-2.jpg',
      '/assets/residential/deyaar/midtown-3.jpg',
      '/assets/residential/deyaar/midtown-4.jpg',
      '/assets/residential/deyaar/midtown-5.jpg',
    ]
  },

  'majid-al-futtaim-tilal-al-ghaf': {
    title: 'Tilal Al Ghaf',
    location: 'Dubai, UAE',
    type: 'Villas & Townhouses',
    builder: 'Majid Al Futtaim',
    floors: 'Master Community',
    category: 'Residential',
    bedrooms: '3-6 BR',
    bathrooms: '3-6',
    area: 'Master Community',
    isFeatured: true,
    description: 'Tilal Al Ghaf is a master-planned community by Majid Al Futtaim offering luxury villas and townhouses with lagoons, parks, and world-class amenities. Experience nature-inspired living.',
    ellingtonPricing: {
      startingPrice: {
        aed: 3800000
      },
      paymentPlan: 'Flexible Payment Plan',
      highlights: 'Nature-inspired master community'
    },
    specialFeatures: [
      'Starting from AED 3.8M',
      'Flexible Payment Plan',
      'Master community',
      'Crystal lagoons',
      'Parks & nature',
      '3-6 bedroom homes',
      'World-class amenities',
      'MAF development'
    ],
    features: [
      { icon: 'FaHome', text: 'Luxury Homes' },
      { icon: 'FaWater', text: 'Crystal Lagoon' },
      { icon: 'FaTree', text: 'Nature Parks' },
      { icon: 'FaSwimmingPool', text: 'Community Pools' },
      { icon: 'FaDumbbell', text: 'Fitness Centers' },
      { icon: 'FaCar', text: 'Private Parking' },
      { icon: 'FaShieldAlt', text: 'Gated Security' },
      { icon: 'FaShoppingBag', text: 'Retail Access' }
    ],
    contact: {
      name: 'Community Sales Team',
      position: 'Property Consultant',
      company: 'Majid Al Futtaim',
      phone: '+971XXXXXXXXX',
      email: 'tilal@maf.ae'
    },
    media: [
      {
        type: 'video',
        src: '/assets/residential/maf/tilal-al-ghaf-video.mp4',
        poster: '/assets/residential/maf/tilal-al-ghaf.jpg'
      },
      {
        type: 'image',
        src: '/assets/residential/maf/tilal-al-ghaf.jpg'
      },
      {
        type: 'image',
        src: '/assets/residential/maf/tilal-al-ghaf-1.jpg'
      },
      {
        type: 'image',
        src: '/assets/residential/maf/tilal-al-ghaf-2.jpg'
      },
      {
        type: 'image',
        src: '/assets/residential/maf/tilal-al-ghaf-3.jpg'
      },
      {
        type: 'image',
        src: '/assets/residential/maf/tilal-al-ghaf-4.jpg'
      },
      {
        type: 'image',
        src: '/assets/residential/maf/tilal-al-ghaf-5.jpg'
      }
    ]
  },

  'nshama-town-square': {
    title: 'Town Square Dubai',
    location: 'Town Square, Dubai, UAE',
    type: 'Apartments & Townhouses',
    builder: 'Nshama',
    floors: 'Master Community',
    category: 'Residential',
    bedrooms: 'Studio-4 BR',
    bathrooms: '1-4',
    area: 'Master Community',
    isFeatured: true,
    description: 'Town Square Dubai by Nshama is a vibrant master community offering apartments and townhouses with parks, schools, and retail. Experience family-friendly living with excellent value.',
    ellingtonPricing: {
      startingPrice: {
        aed: 528000
      },
      paymentPlan: 'Flexible Payment Plan',
      highlights: 'Vibrant master community living'
    },
    specialFeatures: [
      'Starting from AED 528K',
      'Flexible Payment Plan',
      'Master community',
      'Family-friendly',
      'Parks & schools',
      'Town Square Mall',
      'Studios to 4BR',
      'Great value'
    ],
    features: [
      { icon: 'FaHome', text: 'Diverse Homes' },
      { icon: 'FaChild', text: 'Family Community' },
      { icon: 'FaTree', text: 'Central Park' },
      { icon: 'FaSwimmingPool', text: 'Swimming Pools' },
      { icon: 'FaDumbbell', text: 'Fitness Centers' },
      { icon: 'FaCar', text: 'Covered Parking' },
      { icon: 'FaShieldAlt', text: '24/7 Security' },
      { icon: 'FaShoppingBag', text: 'Town Square Mall' }
    ],
    contact: {
      name: 'Community Sales Team',
      position: 'Property Consultant',
      company: 'Nshama',
      phone: '+971XXXXXXXXX',
      email: 'sales@nshama.com'
    },
    images: [
      '/assets/residential/nshama/town-square.jpg',
      '/assets/residential/nshama/town-square-1.jpg',
      '/assets/residential/nshama/town-square-2.jpg',
      '/assets/residential/nshama/town-square-3.jpg',
      '/assets/residential/nshama/town-square-4.jpg',
      '/assets/residential/nshama/town-square-5.jpg',
    ]
  }

,
'tiger-group-dubai-hills': {
  title: 'Tiger Properties Dubai Hills',
  location: 'Dubai Hills Estate, Dubai, UAE',
  type: '1, 2 & 3BR Apartments',
  builder: 'Tiger Group',
  floors: 'Mid-Rise',
  category: 'Residential',
  bedrooms: '1-3 BR',
  bathrooms: '1-3',
  area: 'Multiple Units',
  isFeatured: false,
  description: 'Tiger Properties in Dubai Hills Estate offers modern apartments with golf course views and premium amenities. Experience quality living in one of Dubai\'s most prestigious communities.',
  ellingtonPricing: {
    startingPrice: {
      aed: 1160000
    },
    paymentPlan: 'Flexible Payment Plan',
    highlights: 'Dubai Hills Estate living'
  },
  specialFeatures: [
    'Starting from AED 1.16M',
    'Flexible Payment Plan',
    'Dubai Hills Estate',
    'Golf course views',
    '1-3 bedroom apartments',
    'Premium amenities',
    'Completion 2026'
  ],
  features: [
    { icon: 'FaGolfBall', text: 'Golf Views' },
    { icon: 'FaHome', text: 'Modern Apartments' },
    { icon: 'FaSwimmingPool', text: 'Swimming Pool' },
    { icon: 'FaDumbbell', text: 'Fitness Center' },
    { icon: 'FaTree', text: 'Green Spaces' },
    { icon: 'FaCar', text: 'Covered Parking' },
    { icon: 'FaShieldAlt', text: '24/7 Security' },
    { icon: 'FaBuilding', text: 'Modern Design' }
  ],
  contact: {
    name: 'Sales Team',
    position: 'Property Consultant',
    company: 'Tiger Group',
    phone: '+971XXXXXXXXX',
    email: 'sales@tigergroup.ae'
  },
  images: [
    '/assets/residential/tiger/dubai-hills.jpg',
    '/assets/residential/tiger/dubai-hills-1.jpg',
    '/assets/residential/tiger/dubai-hills-2.jpg',
    '/assets/residential/tiger/dubai-hills-3.jpg',
    '/assets/residential/tiger/dubai-hills-4.jpg',
    '/assets/residential/tiger/dubai-hills-5.jpg',
  ]
},

'binghatti-skyrise-business-bay': {
  title: 'Binghatti Skyrise',
  location: 'Business Bay, Dubai, UAE',
  type: 'Studios, 1, 2 & 3BR Apartments',
  builder: 'Binghatti',
  floors: 'Ground + 48 Floors (3 Towers)',
  category: 'Residential',
  bedrooms: 'Studio-3 BR',
  bathrooms: '1-3',
  area: '422-2,271 sq.ft',
  isFeatured: true,
  description: 'Binghatti Skyrise comprises three contemporary high-rise towers in Business Bay offering studios to 3-bedroom apartments with stunning city views. This modern development features Binghatti\'s signature architectural design with premium finishes and amenities.',
  ellingtonPricing: {
    startingPrice: {
      aed: 975000
    },
    paymentPlan: '70/30 Payment Plan (10% Booking)',
    highlights: 'Affordable luxury in Business Bay'
  },
  specialFeatures: [
    'Starting from AED 975K',
    '70/30 Payment Plan',
    '10% Down Payment',
    'Business Bay location',
    'Studios to 3BR',
    '3 Towers - 48 Floors',
    'City views',
    'Handover 2026'
  ],
  features: [
    { icon: 'FaBuilding', text: 'High-Rise Tower' },
    { icon: 'FaCity', text: 'City Views' },
    { icon: 'FaSwimmingPool', text: 'Swimming Pool' },
    { icon: 'FaDumbbell', text: 'Modern Gym' },
    { icon: 'FaCar', text: 'Covered Parking' },
    { icon: 'FaShieldAlt', text: '24/7 Security' },
    { icon: 'FaHome', text: 'Modern Design' },
    { icon: 'FaStar', text: 'Affordable Luxury' }
  ],
  contact: {
    name: 'Sales Team',
    position: 'Property Consultant',
    company: 'Binghatti',
    phone: '+971XXXXXXXXX',
    email: 'sales@binghatti.com'
  },
  media: [
    {
      type: 'video',
      src: '/assets/residential/binghatti/binghatti-skyrise-video.mp4',
      poster: '/assets/residential/binghatti/binghatti-skyrise.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/binghatti/binghatti-skyrise.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/binghatti/binghatti-skyrise-1.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/binghatti/binghatti-skyrise-2.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/binghatti/binghatti-skyrise-3.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/binghatti/binghatti-skyrise-4.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/binghatti/binghatti-skyrise-5.jpg'
    }
  ]
},

'bay-grove-nakheel': {
  title: 'Bay Grove Residences',
  location: 'Dubai Islands, Dubai, UAE',
  type: '1, 2, 3BR & 4BR Penthouses',
  builder: 'Nakheel',
  floors: 'G+7 to G+20 Residential Towers',
  category: 'Residential',
  bedrooms: '1-4 BR',
  bathrooms: '1-4',
  area: '870-3,797 sq.ft',
  isFeatured: true,
  description: 'Bay Grove Residences at Dubai Islands offers contemporary waterfront living with stunning sea views and direct beach access. This modern development features premium apartments with world-class amenities in a vibrant island community.',
  ellingtonPricing: {
    startingPrice: {
      aed: 1850000
    },
    paymentPlan: '70/30 Payment Plan',
    highlights: 'Waterfront island living with beach access'
  },
  specialFeatures: [
    'Starting from AED 1.85M',
    '70/30 Payment Plan',
    'Dubai Islands location',
    'Waterfront views',
    'Direct beach access',
    'Modern amenities',
    'G+7 to G+20 towers',
    'Handover Q3 2028'
  ],
  features: [
    { icon: 'FaUmbrellaBeach', text: 'Beach Access' },
    { icon: 'FaSwimmingPool', text: 'Swimming Pool' },
    { icon: 'FaDumbbell', text: 'Fitness Center' },
    { icon: 'FaWater', text: 'Waterfront Views' },
    { icon: 'FaCar', text: 'Covered Parking' },
    { icon: 'FaShieldAlt', text: '24/7 Security' },
    { icon: 'FaChild', text: 'Kids Play Area' },
    { icon: 'FaTree', text: 'Landscaped Gardens' }
  ],
  contact: {
    name: 'Sales Team',
    position: 'Property Consultant',
    company: 'Nakheel',
    phone: '+971XXXXXXXXX',
    email: 'sales@nakheel.ae'
  },
  media: [
    {
      type: 'video',
      src: '/assets/residential/nakheel/bay-grove-video.mp4',
      poster: '/assets/residential/nakheel/bay-grove.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/nakheel/bay-grove.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/nakheel/bay-grove-1.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/nakheel/bay-grove-2.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/nakheel/bay-grove-3.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/nakheel/bay-grove-4.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/nakheel/bay-grove-5.jpg'
    }
  ]
},

'bay-villas-nakheel': {
  title: 'Bay Villas',
  location: 'Dubai Islands, Dubai, UAE',
  type: '3, 4 & 5BR Beachfront Villas',
  builder: 'Nakheel',
  floors: 'Beachfront Villa Community',
  category: 'Residential',
  bedrooms: '3-5 BR',
  bathrooms: '3-5',
  area: '3BR Duet from 280 sqm, 5BR Waterfront from 674 sqm',
  isFeatured: true,
  isLuxury: true,
  description: 'Bay Villas offers exclusive beachfront living on Dubai Islands with luxurious 3 to 5-bedroom villas. Each villa features private beach access, contemporary design, and premium finishes with stunning sea views.',
  ellingtonPricing: {
    startingPrice: {
      aed: 4000000
    },
    paymentPlan: '80/20 Payment Plan',
    highlights: 'Exclusive beachfront villas with private beach'
  },
  specialFeatures: [
    'Starting from AED 4M',
    '80/20 Payment Plan',
    '3-5 bedroom villas',
    'Duet villas from AED 5.2M',
    'Garden villas from AED 8.5M',
    'Waterfront villas from AED 13.8M',
    'Private beach access',
    'Handover Q2 2027'
  ],
  features: [
    { icon: 'FaUmbrellaBeach', text: 'Private Beach' },
    { icon: 'FaSwimmingPool', text: 'Private Pool' },
    { icon: 'FaHome', text: 'Luxury Villas' },
    { icon: 'FaTree', text: 'Private Gardens' },
    { icon: 'FaCar', text: 'Private Parking' },
    { icon: 'FaShieldAlt', text: 'Gated Community' },
    { icon: 'FaSpa', text: 'Wellness Amenities' },
    { icon: 'FaDumbbell', text: 'Fitness Center' }
  ],
  contact: {
    name: 'Luxury Villa Team',
    position: 'Villa Specialist',
    company: 'Nakheel',
    phone: '+971XXXXXXXXX',
    email: 'villas@nakheel.ae'
  },
  media: [
    {
      type: 'video',
      src: '/assets/residential/nakheel/bay-villas-video.mp4',
      poster: '/assets/residential/nakheel/bay-villas.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/nakheel/bay-villas.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/nakheel/bay-villas-1.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/nakheel/bay-villas-2.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/nakheel/bay-villas-3.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/nakheel/bay-villas-4.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/nakheel/bay-villas-5.jpg'
    }
  ]
},

'palm-jebel-ali-nakheel': {
  title: 'Palm Jebel Ali',
  location: 'Palm Jebel Ali, Dubai, UAE',
  type: 'Luxury Villas & Apartments',
  builder: 'Nakheel',
  floors: 'Master Development',
  category: 'Residential',
  bedrooms: '2-6 BR',
  bathrooms: '2-6',
  area: 'Master Planned Community',
  isFeatured: true,
  isLuxury: true,
  description: 'Palm Jebel Ali is Nakheel\'s newest iconic palm-shaped island offering ultra-luxury villas and apartments. This master-planned development features world-class resorts, marinas, and pristine beaches with unparalleled luxury living.',
  ellingtonPricing: {
    startingPrice: {
      aed: 18500000
    },
    paymentPlan: '80/20 Payment Plan',
    highlights: 'Iconic palm island with ultra-luxury living'
  },
  specialFeatures: [
    'Starting from AED 18.5M',
    '80/20 Payment Plan',
    'Palm-shaped island',
    'Beach Collection from AED 25.2M',
    'Coral Collection from AED 42.6M',
    'World-class resorts',
    'Private marinas',
    'Iconic development'
  ],
  features: [
    { icon: 'FaCrown', text: 'Ultra Luxury' },
    { icon: 'FaUmbrellaBeach', text: 'Private Beaches' },
    { icon: 'FaShip', text: 'Private Marina' },
    { icon: 'FaSwimmingPool', text: 'Infinity Pools' },
    { icon: 'FaSpa', text: 'Resort Amenities' },
    { icon: 'FaDumbbell', text: 'Premium Gym' },
    { icon: 'FaShieldAlt', text: 'Concierge Services' },
    { icon: 'FaUtensils', text: 'Fine Dining' }
  ],
  contact: {
    name: 'Palm Sales Team',
    position: 'Senior Consultant',
    company: 'Nakheel',
    phone: '+971XXXXXXXXX',
    email: 'palmjebel@nakheel.ae'
  },
  media: [
    {
      type: 'video',
      src: '/assets/residential/nakheel/palm-jebel-ali-video.mp4',
      poster: '/assets/residential/nakheel/palm-jebel-ali.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/nakheel/palm-jebel-ali.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/nakheel/palm-jebel-ali-1.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/nakheel/palm-jebel-ali-2.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/nakheel/palm-jebel-ali-3.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/nakheel/palm-jebel-ali-4.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/nakheel/palm-jebel-ali-5.jpg'
    }
  ]
},

'como-residences-nakheel': {
  title: 'COMO Residences',
  location: 'Palm Jumeirah, Dubai, UAE',
  type: '2-7BR Ultra-Luxury Residences',
  builder: 'Nakheel',
  floors: 'Ultra-Luxury Tower (71 Floors)',
  category: 'Residential',
  bedrooms: '2-7 BR',
  bathrooms: '2-7',
  area: '4,470-11,435+ sq.ft',
  isFeatured: true,
  isLuxury: true,
  description: 'COMO Residences is Palm Jumeirah\'s tallest residential tower offering ultra-luxury 2 to 7-bedroom residences with panoramic views. This iconic 71-floor development features world-class amenities, private beach access, and bespoke interiors.',
  ellingtonPricing: {
    startingPrice: {
      aed: 21000000
    },
    paymentPlan: '10% Down, 50% During Construction, 40% On Handover',
    highlights: 'Palm Jumeirah\'s tallest tower with ultra-luxury'
  },
  specialFeatures: [
    'Starting from AED 21M',
    '10-50-40 Payment Plan',
    'Tallest tower on Palm (71 floors)',
    '2BR from AED 21M',
    '3BR from AED 32M',
    '4BR from AED 52M',
    '5BR from AED 73M',
    'Handover March 2027'
  ],
  features: [
    { icon: 'FaCrown', text: 'Ultra Luxury' },
    { icon: 'FaBuilding', text: 'Tallest Tower' },
    { icon: 'FaUmbrellaBeach', text: 'Private Beach' },
    { icon: 'FaSwimmingPool', text: 'Infinity Pools' },
    { icon: 'FaSpa', text: 'COMO Spa' },
    { icon: 'FaDumbbell', text: 'Premium Fitness' },
    { icon: 'FaCar', text: 'Valet Service' },
    { icon: 'FaShieldAlt', text: 'Concierge 24/7' }
  ],
  contact: {
    name: 'COMO Sales Team',
    position: 'Luxury Specialist',
    company: 'Nakheel',
    phone: '+971XXXXXXXXX',
    email: 'como@nakheel.ae'
  },
  media: [
    {
      type: 'video',
      src: '/assets/residential/nakheel/como-residences-video.mp4',
      poster: '/assets/residential/nakheel/como-residences.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/nakheel/como-residences.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/nakheel/como-residences-1.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/nakheel/como-residences-2.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/nakheel/como-residences-3.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/nakheel/como-residences-4.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/nakheel/como-residences-5.jpg'
    }
  ]
},

'rixos-residences-nakheel': {
  title: 'Rixos Dubai Islands Hotel & Residences',
  location: 'Dubai Islands, Dubai, UAE',
  type: 'Branded Residences & Villas',
  builder: 'Nakheel',
  floors: 'High-Rise + Villas',
  category: 'Residential',
  bedrooms: '1-4 BR Apartments + Beach Houses & Villas',
  bathrooms: '1-4+',
  area: 'Branded Development',
  isFeatured: true,
  isLuxury: true,
  description: 'Rixos Dubai Islands brings luxury branded living with hotel-serviced apartments, beach houses, and villas. Experience 5-star Rixos hospitality with private beach access, resort amenities, and world-class dining.',
  ellingtonPricing: {
    startingPrice: {
      aed: 2600000
    },
    paymentPlan: 'Flexible Payment Plan',
    highlights: '5-star branded residences with hotel services'
  },
  specialFeatures: [
    'Starting from AED 2.6M',
    'Flexible Payment Plan',
    'Rixos branded',
    '1BR from AED 2.6M',
    '2BR from AED 4.5M',
    '3BR from AED 6.6M',
    'Beach Houses from AED 9.3M',
    'Handover Q4 2026'
  ],
  features: [
    { icon: 'FaCrown', text: 'Branded Residences' },
    { icon: 'FaUmbrellaBeach', text: 'Private Beach' },
    { icon: 'FaSwimmingPool', text: 'Resort Pools' },
    { icon: 'FaSpa', text: 'Rixos Spa' },
    { icon: 'FaUtensils', text: 'Fine Dining' },
    { icon: 'FaDumbbell', text: 'Premium Gym' },
    { icon: 'FaCar', text: 'Valet Parking' },
    { icon: 'FaShieldAlt', text: 'Hotel Services' }
  ],
  contact: {
    name: 'Branded Sales Team',
    position: 'Senior Consultant',
    company: 'Nakheel',
    phone: '+971XXXXXXXXX',
    email: 'rixos@nakheel.ae'
  },
  media: [
    {
      type: 'video',
      src: '/assets/residential/nakheel/rixos-video.mp4',
      poster: '/assets/residential/nakheel/rixos.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/nakheel/rixos.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/nakheel/rixos-1.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/nakheel/rixos-2.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/nakheel/rixos-3.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/nakheel/rixos-4.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/nakheel/rixos-5.jpg'
    }
  ]
},

'palm-beach-towers-nakheel': {
  title: 'Palm Beach Towers',
  location: 'Palm Jumeirah, Dubai, UAE',
  type: '1, 2, 3 & 4BR Apartments',
  builder: 'Nakheel',
  floors: '3 Towers (51 Floors Each)',
  category: 'Residential',
  bedrooms: '1-4 BR',
  bathrooms: '1-4',
  area: '910-3,885 sq.ft',
  isFeatured: true,
  description: 'Palm Beach Towers features three elegant 51-floor towers on Palm Jumeirah offering 1 to 4-bedroom apartments with stunning sea views. This premium development includes beach access, pools, and world-class amenities.',
  ellingtonPricing: {
    startingPrice: {
      aed: 3700000
    },
    paymentPlan: '15% Down, 45% During Construction, 40% On Handover',
    highlights: 'Palm Jumeirah living with beach access'
  },
  specialFeatures: [
    'Starting from AED 3.7M',
    '15-45-40 Payment Plan',
    '3 towers - 51 floors',
    'Palm Jumeirah',
    'Beach access',
    'Sea views',
    '1,265 premium residences',
    'Handover January 2026'
  ],
  features: [
    { icon: 'FaUmbrellaBeach', text: 'Beach Access' },
    { icon: 'FaBuilding', text: '3 Towers' },
    { icon: 'FaSwimmingPool', text: 'Swimming Pools' },
    { icon: 'FaDumbbell', text: 'Fitness Center' },
    { icon: 'FaWater', text: 'Sea Views' },
    { icon: 'FaCar', text: 'Covered Parking' },
    { icon: 'FaShieldAlt', text: '24/7 Security' },
    { icon: 'FaChild', text: 'Kids Play Area' }
  ],
  contact: {
    name: 'Palm Sales Team',
    position: 'Property Consultant',
    company: 'Nakheel',
    phone: '+971XXXXXXXXX',
    email: 'palmbeach@nakheel.ae'
  },
  media: [
    {
      type: 'video',
      src: '/assets/residential/nakheel/palm-beach-towers-video.mp4',
      poster: '/assets/residential/nakheel/palm-beach-towers.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/nakheel/palm-beach-towers.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/nakheel/palm-beach-towers-1.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/nakheel/palm-beach-towers-2.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/nakheel/palm-beach-towers-3.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/nakheel/palm-beach-towers-4.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/nakheel/palm-beach-towers-5.jpg'
    }
  ]
},

'jebel-ali-village-nakheel': {
  title: 'Jebel Ali Village',
  location: 'Jebel Ali, Dubai, UAE',
  type: 'Villas & Townhouses',
  builder: 'Nakheel',
  floors: 'Villa Community',
  category: 'Residential',
  bedrooms: '3-5 BR',
  bathrooms: '3-5',
  area: 'Gated Community',
  isFeatured: false,
  description: 'Jebel Ali Village offers family-friendly villas and townhouses in a gated community with schools, parks, and retail outlets. This established community provides spacious homes with modern amenities.',
  ellingtonPricing: {
    startingPrice: {
      aed: 2500000
    },
    paymentPlan: 'Flexible Payment Plan',
    highlights: 'Family-friendly gated community'
  },
  specialFeatures: [
    'Starting from AED 2.5M',
    'Flexible Payment Plan',
    'Gated community',
    'Family-friendly',
    'Schools nearby',
    'Parks & recreation',
    'Retail outlets',
    'Spacious villas'
  ],
  features: [
    { icon: 'FaHome', text: 'Spacious Villas' },
    { icon: 'FaChild', text: 'Family Community' },
    { icon: 'FaTree', text: 'Parks & Gardens' },
    { icon: 'FaSwimmingPool', text: 'Community Pool' },
    { icon: 'FaDumbbell', text: 'Fitness Facilities' },
    { icon: 'FaCar', text: 'Private Parking' },
    { icon: 'FaShieldAlt', text: 'Gated Security' },
    { icon: 'FaShoppingBag', text: 'Retail Access' }
  ],
  contact: {
    name: 'Villa Sales Team',
    position: 'Property Consultant',
    company: 'Nakheel',
    phone: '+971XXXXXXXXX',
    email: 'jebel@nakheel.ae'
  },
  media: [
    {
      type: 'video',
      src: '/assets/residential/nakheel/jebel-ali-village-video.mp4',
      poster: '/assets/residential/nakheel/jebel-ali-village.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/nakheel/jebel-ali-village.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/nakheel/jebel-ali-village-1.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/nakheel/jebel-ali-village-2.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/nakheel/jebel-ali-village-3.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/nakheel/jebel-ali-village-4.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/nakheel/jebel-ali-village-5.jpg'
    }
  ]
},

'tilal-nakheel': {
  title: 'Tilal',
  location: 'Dubai Islands, Dubai, UAE',
  type: '1, 2 & 3BR Apartments',
  builder: 'Nakheel',
  floors: 'Mid-Rise',
  category: 'Residential',
  bedrooms: '1-3 BR',
  bathrooms: '1-3',
  area: 'Island Community',
  isFeatured: false,
  description: 'Tilal at Dubai Islands offers affordable contemporary apartments with waterfront views and beach access. This modern development features well-designed units with community amenities in a vibrant island setting.',
  ellingtonPricing: {
    startingPrice: {
      aed: 1100000
    },
    paymentPlan: 'Flexible Payment Plan',
    highlights: 'Affordable island living'
  },
  specialFeatures: [
    'Starting from AED 1.1M',
    'Flexible Payment Plan',
    'Dubai Islands',
    'Affordable pricing',
    'Waterfront community',
    'Beach access',
    'Modern design',
    'Completion 2027'
  ],
  features: [
    { icon: 'FaHome', text: 'Modern Apartments' },
    { icon: 'FaUmbrellaBeach', text: 'Beach Access' },
    { icon: 'FaSwimmingPool', text: 'Swimming Pool' },
    { icon: 'FaDumbbell', text: 'Fitness Center' },
    { icon: 'FaCar', text: 'Covered Parking' },
    { icon: 'FaShieldAlt', text: '24/7 Security' },
    { icon: 'FaChild', text: 'Kids Play Area' },
    { icon: 'FaTree', text: 'Green Spaces' }
  ],
  contact: {
    name: 'Sales Team',
    position: 'Property Consultant',
    company: 'Nakheel',
    phone: '+971XXXXXXXXX',
    email: 'sales@nakheel.ae'
  },
  media: [
    {
      type: 'video',
      src: '/assets/residential/nakheel/tilal-video.mp4',
      poster: '/assets/residential/nakheel/tilal.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/nakheel/tilal.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/nakheel/tilal-1.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/nakheel/tilal-2.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/nakheel/tilal-3.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/nakheel/tilal-4.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/nakheel/tilal-5.jpg'
    }
  ]
},

'murooj-nakheel': {
  title: 'Murooj',
  location: 'Dubai Islands, Dubai, UAE',
  type: '1, 2 & 3BR Apartments',
  builder: 'Nakheel',
  floors: 'Mid-Rise',
  category: 'Residential',
  bedrooms: '1-3 BR',
  bathrooms: '1-3',
  area: 'Island Community',
  isFeatured: false,
  description: 'Murooj at Dubai Islands provides affordable waterfront living with modern apartments and community amenities. This well-planned development offers quality homes with beach access and island lifestyle.',
  ellingtonPricing: {
    startingPrice: {
      aed: 1000000
    },
    paymentPlan: 'Flexible Payment Plan',
    highlights: 'Affordable waterfront living'
  },
  specialFeatures: [
    'Starting from AED 1M',
    'Flexible Payment Plan',
    'Dubai Islands',
    'Affordable entry point',
    'Waterfront living',
    'Beach access',
    'Modern amenities',
    'Completion 2027'
  ],
  features: [
    { icon: 'FaHome', text: 'Affordable Living' },
    { icon: 'FaUmbrellaBeach', text: 'Beach Access' },
    { icon: 'FaSwimmingPool', text: 'Swimming Pool' },
    { icon: 'FaDumbbell', text: 'Fitness Center' },
    { icon: 'FaCar', text: 'Covered Parking' },
    { icon: 'FaShieldAlt', text: '24/7 Security' },
    { icon: 'FaChild', text: 'Kids Play Area' },
    { icon: 'FaTree', text: 'Green Spaces' }
  ],
  contact: {
    name: 'Sales Team',
    position: 'Property Consultant',
    company: 'Nakheel',
    phone: '+971XXXXXXXXX',
    email: 'sales@nakheel.ae'
  },
  media: [
    {
      type: 'video',
      src: '/assets/residential/nakheel/murooj-video.mp4',
      poster: '/assets/residential/nakheel/murooj.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/nakheel/murooj.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/nakheel/murooj-1.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/nakheel/murooj-2.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/nakheel/murooj-3.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/nakheel/murooj-4.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/nakheel/murooj-5.jpg'
    }
  ]
},

'sobha-one-hartland': {
  title: 'Sobha One',
  location: 'Sobha Hartland, Dubai, UAE',
  type: '1, 2, 3, 4 & 5BR Apartments',
  builder: 'Sobha Realty',
  floors: '5 Interconnected Towers',
  category: 'Residential',
  bedrooms: '1-5 BR',
  bathrooms: '1-5',
  area: '5 Tower Complex',
  isFeatured: true,
  description: 'Sobha One features five interconnected luxury towers in Sobha Hartland with world-class amenities including yoga zones, swimming pools, and nature trails. Experience modern waterfront living with stunning views and premium finishes.',
  ellingtonPricing: {
    startingPrice: {
      aed: 1100000
    },
    paymentPlan: '60/40 Payment Plan (20% Down Payment)',
    highlights: 'Five interconnected towers with premium amenities'
  },
  specialFeatures: [
    'Starting from AED 1.1M',
    '60/40 Payment Plan',
    '20% Down Payment',
    '5 interconnected towers',
    'Yoga zones & pools',
    'Nature trails',
    'Waterfront location',
    'Handover Q4 2026'
  ],
  features: [
    { icon: 'FaSwimmingPool', text: 'Multiple Pools' },
    { icon: 'FaDumbbell', text: 'Premium Gym' },
    { icon: 'FaSpa', text: 'Yoga & Wellness Zones' },
    { icon: 'FaTree', text: 'Nature Trails' },
    { icon: 'FaCar', text: 'Covered Parking' },
    { icon: 'FaShieldAlt', text: '24/7 Security' },
    { icon: 'FaChild', text: 'Kids Play Area' },
    { icon: 'FaBuilding', text: 'Modern Architecture' }
  ],
  contact: {
    name: 'Sales Team',
    position: 'Property Consultant',
    company: 'Sobha Realty',
    phone: '+971XXXXXXXXX',
    email: 'sales@sobharealty.com'
  },
  images: [
    '/assets/residential/sobha/sobha-one.jpg',
    '/assets/residential/sobha/sobha-one-1.jpg',
    '/assets/residential/sobha/sobha-one-2.jpg',
    '/assets/residential/sobha/sobha-one-3.jpg',
    '/assets/residential/sobha/sobha-one-4.jpg',
    '/assets/residential/sobha/sobha-one-5.jpg',
  ]
}
,
'sobha-seahaven-hartland': {
  title: 'Sobha SeaHaven',
  location: 'Sobha Hartland II, Dubai, UAE',
  type: '1-6BR Waterfront Apartments & Penthouses',
  builder: 'Sobha Realty',
  floors: 'High-Rise',
  category: 'Residential',
  bedrooms: '1-6 BR',
  bathrooms: '1-6',
  area: 'Ultra-Luxury Waterfront Tower',
  isFeatured: true,
  isLuxury: true,
  description: 'Sobha SeaHaven offers luxurious waterfront living at Dubai Harbour with stunning sea views. This premium ultra-luxury development features 1 to 6-bedroom apartments and penthouses with world-class amenities and exclusive lush landscaping.',
  ellingtonPricing: {
    startingPrice: {
      aed: 1800000
    },
    paymentPlan: '60/40 Payment Plan',
    highlights: 'Ultra-luxury waterfront at Dubai Harbour'
  },
  specialFeatures: [
    'Starting from AED 1.8M',
    '60/40 Payment Plan',
    'Dubai Harbour location',
    'Sea-facing views',
    '1-6 bedroom options',
    '6BR Penthouse AED 135M',
    'Premium amenities',
    'Handover Q4 2026'
  ],
  features: [
    { icon: 'FaWater', text: 'Sea Views' },
    { icon: 'FaSwimmingPool', text: 'Waterfront Pool' },
    { icon: 'FaDumbbell', text: 'Fitness Center' },
    { icon: 'FaTree', text: 'Lush Landscaping' },
    { icon: 'FaCar', text: 'Covered Parking' },
    { icon: 'FaShieldAlt', text: '24/7 Security' },
    { icon: 'FaChild', text: 'Kids Play Area' },
    { icon: 'FaCrown', text: 'Ultra-Luxury' }
  ],
  contact: {
    name: 'Sales Team',
    position: 'Property Consultant',
    company: 'Sobha Realty',
    phone: '+971XXXXXXXXX',
    email: 'sales@sobharealty.com'
  },
  images: [
    '/assets/residential/sobha/sobha-seahaven.jpg',
    '/assets/residential/sobha/sobha-seahaven-1.jpg',
    '/assets/residential/sobha/sobha-seahaven-2.jpg',
    '/assets/residential/sobha/sobha-seahaven-3.jpg',
    '/assets/residential/sobha/sobha-seahaven-4.jpg',
    '/assets/residential/sobha/sobha-seahaven-5.jpg'
  ]
},

'golf-ridges-sobha': {
  title: 'Golf Ridges',
  location: 'Sobha Hartland, Dubai, UAE',
  type: '4 & 5BR Golf Course Villas',
  builder: 'Sobha Realty',
  floors: 'Luxury Villas',
  category: 'Residential',
  bedrooms: '4-5 BR',
  bathrooms: '4-5',
  area: 'Golf Course Community',
  isFeatured: true,
  isLuxury: true,
  description: 'Golf Ridges offers luxury villas overlooking a world-class 18-hole golf course. This exclusive development combines modern villas with premium golf amenities, perfect for golf enthusiasts and luxury seekers.',
  ellingtonPricing: {
    startingPrice: {
      aed: 6700000
    },
    paymentPlan: '60/40 Payment Plan (20% Down)',
    highlights: 'Golf course views & premium lifestyle'
  },
  specialFeatures: [
    'Starting from AED 6.7M',
    '60/40 Payment Plan',
    '20% Down Payment',
    'World-class 18-hole golf',
    'Luxury 4 & 5 BR villas',
    'Private lifts',
    'Separate lobbies',
    'Handover Q4 2026'
  ],
  features: [
    { icon: 'FaGolfBall', text: 'Golf Course Access' },
    { icon: 'FaHome', text: 'Luxury Villas' },
    { icon: 'FaSwimmingPool', text: 'Swimming Pool' },
    { icon: 'FaDumbbell', text: 'Premium Gym' },
    { icon: 'FaTree', text: 'Green Landscapes' },
    { icon: 'FaCar', text: 'Private Parking' },
    { icon: 'FaShieldAlt', text: 'Gated Security' },
    { icon: 'FaBuilding', text: 'Clubhouse' }
  ],
  contact: {
    name: 'Golf Sales Team',
    position: 'Villa Specialist',
    company: 'Sobha Realty',
    phone: '+971XXXXXXXXX',
    email: 'golf@sobharealty.com'
  },
  images: [
    '/assets/residential/sobha/golf-ridges.jpg',
    '/assets/residential/sobha/golf-ridges-1.jpg',
    '/assets/residential/sobha/golf-ridges-2.jpg',
    '/assets/residential/sobha/golf-ridges-3.jpg',
    '/assets/residential/sobha/golf-ridges-4.jpg',
    '/assets/residential/sobha/golf-ridges-5.jpg'
  ]
},

'sobha-estates-villas': {
  title: 'Sobha Estates Villas',
  location: 'Sobha Hartland II, Dubai, UAE',
  type: '5BR Signature Luxury Villas',
  builder: 'Sobha Realty',
  floors: 'Ground + 2 Floors',
  category: 'Residential',
  bedrooms: '5 BR',
  bathrooms: '6',
  area: '8,438-8,503 sq.ft',
  isFeatured: true,
  isLuxury: true,
  description: 'Sobha Estates Villas presents signature 5-bedroom luxury villas in Sobha Hartland II, surrounded by lush greenery. These expansive G+2 villas offer over 8,400 sq ft of luxury living with premium finishes, private pools, and landscaped gardens.',
  ellingtonPricing: {
    startingPrice: {
      aed: 22784760
    },
    paymentPlan: '80/20 Payment Plan',
    highlights: 'Ultra-luxury villas with 8,400+ sq ft'
  },
  specialFeatures: [
    'Starting from AED 22.78M',
    '80/20 Payment Plan',
    '5 bedroom villas',
    '8,438-8,503 sq ft',
    'Ground + 2 Floors',
    'Private swimming pools',
    'Landscaped gardens',
    'Handover Q4 2026'
  ],
  features: [
    { icon: 'FaCrown', text: 'Ultra Luxury Villas' },
    { icon: 'FaHome', text: 'Spacious Living' },
    { icon: 'FaSwimmingPool', text: 'Private Pool' },
    { icon: 'FaTree', text: 'Private Gardens' },
    { icon: 'FaCar', text: 'Private Parking' },
    { icon: 'FaShieldAlt', text: 'Gated Security' },
    { icon: 'FaWater', text: 'Water Views' },
    { icon: 'FaSpa', text: 'Wellness Amenities' }
  ],
  contact: {
    name: 'Luxury Villa Team',
    position: 'Villa Specialist',
    company: 'Sobha Realty',
    phone: '+971XXXXXXXXX',
    email: 'villas@sobharealty.com'
  },
  images: [
    '/assets/residential/sobha/sobha-estates-villas.jpg',
    '/assets/residential/sobha/sobha-estates-villas-1.jpg',
    '/assets/residential/sobha/sobha-estates-villas-2.jpg',
    '/assets/residential/sobha/sobha-estates-villas-3.jpg',
    '/assets/residential/sobha/sobha-estates-villas-4.jpg',
    '/assets/residential/sobha/sobha-estates-villas-5.jpg'
  ]
},

'the-roof-residence-sobha': {
  title: 'The Roof Residence',
  location: 'Nad Al Sheba 1, Dubai, UAE',
  type: '1 & 2BR Apartments',
  builder: 'Sobha Realty',
  floors: 'G+2P+6F+R',
  category: 'Residential',
  bedrooms: '1-2 BR',
  bathrooms: '1-2',
  area: '68 Units | 850-1,973 sq.ft',
  isFeatured: false,
  description: 'The Roof Residence offers contemporary 1 and 2-bedroom apartments in Nad Al Sheba 1 with stunning Burj Khalifa views. This mid-rise development features 68 elegant units with private balconies and modern amenities.',
  ellingtonPricing: {
    startingPrice: {
      aed: 1500000
    },
    paymentPlan: 'Flexible Payment Plan',
    highlights: 'Burj Khalifa views in Nad Al Sheba'
  },
  specialFeatures: [
    'Starting from AED 1.5M',
    'Flexible Payment Plan',
    'Burj Khalifa views',
    '68 total units',
    'Private balconies',
    'Maid rooms available',
    'Nad Al Sheba 1',
    'Completion Q4 2025'
  ],
  features: [
    { icon: 'FaCity', text: 'Burj Khalifa Views' },
    { icon: 'FaBuilding', text: 'Modern Design' },
    { icon: 'FaSwimmingPool', text: 'Swimming Pool' },
    { icon: 'FaDumbbell', text: 'Fitness Center' },
    { icon: 'FaCar', text: 'Covered Parking' },
    { icon: 'FaShieldAlt', text: '24/7 Security' },
    { icon: 'FaHome', text: 'Private Balconies' }
  ],
  contact: {
    name: 'Sales Team',
    position: 'Property Consultant',
    company: 'Sobha Realty',
    phone: '+971XXXXXXXXX',
    email: 'sales@sobharealty.com'
  },
  images: [
    '/assets/residential/sobha/the-roof-residence.jpg',
    '/assets/residential/sobha/the-roof-residence-1.jpg',
    '/assets/residential/sobha/the-roof-residence-2.jpg',
    '/assets/residential/sobha/the-roof-residence-3.jpg',
    '/assets/residential/sobha/the-roof-residence-4.jpg',
    '/assets/residential/sobha/the-roof-residence-5.jpg'
  ]
},

'330-riverside-crescent-sobha': {
  title: '330 Riverside Crescent',
  location: 'Sobha Hartland II, Dubai, UAE',
  type: '1, 1.5 & 2BR Apartments',
  builder: 'Sobha Realty',
  floors: 'High-Rise Tower',
  category: 'Residential',
  bedrooms: '1-2 BR',
  bathrooms: '1-2',
  area: '495-1,029 sq.ft',
  isFeatured: true,
  description: '330 Riverside Crescent is a sleek high-rise tower in Sobha Hartland II offering 1, 1.5, and 2-bedroom apartments with sweeping riverside views. This modern development features premium amenities and prime waterfront location.',
  ellingtonPricing: {
    startingPrice: {
      aed: 1630000
    },
    paymentPlan: '60/40 Payment Plan',
    highlights: 'Riverside living with panoramic views'
  },
  specialFeatures: [
    'Starting from AED 1.63M',
    '60/40 Payment Plan',
    'Riverside location',
    'Race course views',
    '1.5 BR available',
    'Premium amenities',
    'Sobha Hartland II',
    'Handover June 2027'
  ],
  features: [
    { icon: 'FaWater', text: 'Riverside Views' },
    { icon: 'FaSwimmingPool', text: 'Swimming Pool' },
    { icon: 'FaDumbbell', text: 'Modern Gym' },
    { icon: 'FaTree', text: 'Landscaped Areas' },
    { icon: 'FaCar', text: 'Covered Parking' },
    { icon: 'FaShieldAlt', text: '24/7 Security' },
    { icon: 'FaBuilding', text: 'High-Rise Tower' }
  ],
  contact: {
    name: 'Sales Team',
    position: 'Property Consultant',
    company: 'Sobha Realty',
    phone: '+971XXXXXXXXX',
    email: 'sales@sobharealty.com'
  },
  images: [
    '/assets/residential/sobha/330-riverside-crescent.jpg',
    '/assets/residential/sobha/330-riverside-crescent-1.jpg',
    '/assets/residential/sobha/330-riverside-crescent-2.jpg',
    '/assets/residential/sobha/330-riverside-crescent-3.jpg',
    '/assets/residential/sobha/330-riverside-crescent-4.jpg',
    '/assets/residential/sobha/330-riverside-crescent-5.jpg'
  ]
},

'sobha-creek-vistas': {
  title: 'Sobha Creek Vistas Heights',
  location: 'Sobha Hartland, Dubai, UAE',
  type: '1, 2 & 3BR Creek Apartments',
  builder: 'Sobha Realty',
  floors: '28-Floor Towers',
  category: 'Residential',
  bedrooms: '1-3 BR',
  bathrooms: '1-3',
  area: 'Creek-side Tower',
  isFeatured: false,
  description: 'Sobha Creek Vistas Heights offers elegant apartments with stunning Dubai Creek, Ras Al Khor Wildlife Sanctuary, and Downtown Dubai views. This premium development features modern design, lush landscapes, and world-class amenities.',
  ellingtonPricing: {
    startingPrice: {
      aed: 1600000
    },
    paymentPlan: 'Flexible Payment Plan',
    highlights: 'Dubai Creek & Downtown views'
  },
  specialFeatures: [
    'Starting from AED 1.6M',
    'Flexible Payment Plan',
    'Dubai Creek views',
    'Ras Al Khor sanctuary views',
    'Downtown Dubai views',
    'Premium finishes',
    'Landscaped gardens',
    'Handover June 2026'
  ],
  features: [
    { icon: 'FaWater', text: 'Creek Views' },
    { icon: 'FaSwimmingPool', text: 'Swimming Pool' },
    { icon: 'FaDumbbell', text: 'Fitness Center' },
    { icon: 'FaTree', text: 'Green Spaces' },
    { icon: 'FaCar', text: 'Covered Parking' },
    { icon: 'FaShieldAlt', text: '24/7 Security' },
    { icon: 'FaChild', text: 'Kids Play Area' }
  ],
  contact: {
    name: 'Sales Team',
    position: 'Property Consultant',
    company: 'Sobha Realty',
    phone: '+971XXXXXXXXX',
    email: 'sales@sobharealty.com'
  },
  images: [
    '/assets/residential/sobha/sobha-creek-vistas.jpg',
    '/assets/residential/sobha/sobha-creek-vistas-1.jpg',
    '/assets/residential/sobha/sobha-creek-vistas-2.jpg',
    '/assets/residential/sobha/sobha-creek-vistas-3.jpg',
    '/assets/residential/sobha/sobha-creek-vistas-4.jpg',
    '/assets/residential/sobha/sobha-creek-vistas-5.jpg'
  ]
},

'sobha-orbis-motor-city': {
  title: 'Sobha Orbis',
  location: 'Motor City, Dubai, UAE',
  type: '1, 1.5 & 2BR Apartments',
  builder: 'Sobha Realty',
  floors: 'Mid-Rise',
  category: 'Residential',
  bedrooms: '1-2 BR',
  bathrooms: '1-2',
  area: 'Mid-Rise Community',
  isFeatured: false,
  description: 'Sobha Orbis offers affordable yet premium living in Motor City with 1, 1.5 and 2-bedroom apartments. This well-designed development features modern amenities and excellent connectivity.',
  ellingtonPricing: {
    startingPrice: {
      aed: 965070
    },
    paymentPlan: '80/20 Payment Plan (20% Down)',
    highlights: 'Affordable premium living in Motor City'
  },
  specialFeatures: [
    'Starting from AED 965K',
    '80/20 Payment Plan',
    '20% Down Payment',
    'Motor City location',
    '1.5 BR available',
    'Affordable luxury',
    'Modern amenities',
    'Handover Q4 2027'
  ],
  features: [
    { icon: 'FaHome', text: 'Affordable Luxury' },
    { icon: 'FaSwimmingPool', text: 'Swimming Pool' },
    { icon: 'FaDumbbell', text: 'Fitness Center' },
    { icon: 'FaCar', text: 'Covered Parking' },
    { icon: 'FaShieldAlt', text: '24/7 Security' },
    { icon: 'FaChild', text: 'Kids Play Area' },
    { icon: 'FaBuilding', text: 'Modern Design' }
  ],
  contact: {
    name: 'Sales Team',
    position: 'Property Consultant',
    company: 'Sobha Realty',
    phone: '+971XXXXXXXXX',
    email: 'sales@sobharealty.com'
  },
  images: [
    '/assets/residential/sobha/sobha-orbis.jpg',
    '/assets/residential/sobha/sobha-orbis-1.jpg',
    '/assets/residential/sobha/sobha-orbis-2.jpg',
    '/assets/residential/sobha/sobha-orbis-3.jpg',
    '/assets/residential/sobha/sobha-orbis-4.jpg',
    '/assets/residential/sobha/sobha-orbis-5.jpg'
  ]
},

'bluewaters-residences-meraas': {
  title: 'Bluewaters Residences',
  location: 'Bluewaters Island, Dubai, UAE',
  type: '1, 2, 3 & 4BR Apartments',
  builder: 'Meraas',
  floors: '10 Apartment Buildings',
  category: 'Residential',
  bedrooms: '1-4 BR',
  bathrooms: '1-4',
  area: '801-2,994 sq.ft',
  isFeatured: true,
  description: 'Bluewaters Residences offers iconic island living with stunning views of the Arabian Gulf and Ain Dubai. This premium development features 10 elegant buildings with world-class amenities and beach access.',
  ellingtonPricing: {
    startingPrice: {
      aed: 1208000
    },
    paymentPlan: 'Flexible Payment Plan',
    highlights: 'Island living with Ain Dubai views'
  },
  specialFeatures: [
    'Starting from AED 1.2M',
    'Flexible Payment Plan',
    'Bluewaters Island location',
    '10 residential buildings',
    'Beach access',
    'Views of Ain Dubai',
    'World-class amenities',
    'Completed Q3 2023'
  ],
  features: [
    { icon: 'FaUmbrellaBeach', text: 'Beach Access' },
    { icon: 'FaSwimmingPool', text: 'Infinity Pool' },
    { icon: 'FaDumbbell', text: 'State-of-art Gym' },
    { icon: 'FaCar', text: 'Covered Parking' },
    { icon: 'FaShieldAlt', text: '24/7 Security' },
    { icon: 'FaChild', text: 'Kids Play Area' },
    { icon: 'FaUtensils', text: 'Restaurants & Cafes' },
    { icon: 'FaShoppingBag', text: 'Retail Outlets' }
  ],
  contact: {
    name: 'Sales Team',
    position: 'Property Consultant',
    company: 'Meraas',
    phone: '+971XXXXXXXXX',
    email: 'sales@meraas.ae'
  },
  media: [
    {
      type: 'video',
      src: '/assets/residential/meraas/bluewaters-residences-video.mp4',
      poster: '/assets/residential/meraas/bluewaters-residences.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/meraas/bluewaters-residences.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/meraas/bluewaters-residences-1.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/meraas/bluewaters-residences-2.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/meraas/bluewaters-residences-3.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/meraas/bluewaters-residences-4.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/meraas/bluewaters-residences-5.jpg'
    }
  ]
},

'port-de-la-mer-meraas': {
  title: 'Port De La Mer',
  location: 'Jumeirah 1, Dubai, UAE',
  type: '1-5BR Luxury Apartments & Townhouses',
  builder: 'Meraas',
  floors: 'Waterfront Community',
  category: 'Residential',
  bedrooms: '1-5 BR',
  bathrooms: '1-5',
  area: '700-9,000 sq.ft',
  isFeatured: true,
  isLuxury: true,
  description: 'Port De La Mer is an ultra-luxury waterfront community with a 190-berth marina, pristine beaches, and contemporary residences. Experience Mediterranean-inspired living with world-class amenities and stunning sea views.',
  ellingtonPricing: {
    startingPrice: {
      aed: 2200000
    },
    paymentPlan: 'Flexible Payment Plan',
    highlights: 'Luxury marina living with beach access'
  },
  specialFeatures: [
    'Starting from AED 2.2M',
    'Flexible Payment Plan',
    '190-berth marina',
    'Private beach access',
    'Mediterranean architecture',
    'Waterfront promenade',
    '3BR townhouses from AED 9M',
    'Luxury amenities'
  ],
  features: [
    { icon: 'FaUmbrellaBeach', text: 'Private Beach' },
    { icon: 'FaShip', text: '190-Berth Marina' },
    { icon: 'FaSwimmingPool', text: 'Infinity Pools' },
    { icon: 'FaDumbbell', text: 'Premium Gym' },
    { icon: 'FaSpa', text: 'Spa & Wellness' },
    { icon: 'FaCar', text: 'Valet Parking' },
    { icon: 'FaShieldAlt', text: 'Concierge Services' },
    { icon: 'FaUtensils', text: 'Waterfront Dining' }
  ],
  contact: {
    name: 'Luxury Sales Team',
    position: 'Senior Consultant',
    company: 'Meraas',
    phone: '+971XXXXXXXXX',
    email: 'luxury@meraas.ae'
  },
  images: [
    '/assets/residential/meraas/port-de-la-mer.jpg',
    '/assets/residential/meraas/port-de-la-mer-1.jpg',
    '/assets/residential/meraas/port-de-la-mer-2.jpg',
    '/assets/residential/meraas/port-de-la-mer-3.jpg',
    '/assets/residential/meraas/port-de-la-mer-4.jpg',
    '/assets/residential/meraas/port-de-la-mer-5.jpg'
  ]
},

'the-acres-phase-2-meraas': {
  title: 'The Acres Phase 3',
  location: 'Dubailand, Dubai, UAE',
  type: '5, 6 & 7BR Luxury Villas',
  builder: 'Meraas',
  floors: 'Gated Villa Community',
  category: 'Residential',
  bedrooms: '5-7 BR',
  bathrooms: '5-7',
  area: '6,913-7,936+ sq.ft',
  isFeatured: true,
  isLuxury: true,
  description: 'The Acres Phase 3 offers exclusive luxury villa living surrounded by nature with swimmable lagoons, lush landscapes, and premium amenities. This gated community provides tranquil family living with modern luxury and smart-home features.',
  ellingtonPricing: {
    startingPrice: {
      aed: 14500000
    },
    paymentPlan: '65/35 Payment Plan (10% Down, 55% During Construction)',
    highlights: 'Luxury villa community with lagoons'
  },
  specialFeatures: [
    'Starting from AED 14.5M',
    '65/35 Payment Plan',
    '10% Down Payment',
    'Gated community',
    'Swimmable lagoons',
    '5, 6 & 7 BR villas',
    'Smart-home features',
    'Handover August 2028'
  ],
  features: [
    { icon: 'FaHome', text: 'Luxury Villas' },
    { icon: 'FaSwimmingPool', text: 'Swimmable Lagoons' },
    { icon: 'FaTree', text: 'Green Landscapes' },
    { icon: 'FaDumbbell', text: 'Fitness Center' },
    { icon: 'FaCar', text: 'Private Parking' },
    { icon: 'FaShieldAlt', text: 'Gated Security' },
    { icon: 'FaChild', text: 'Kids Play Areas' },
    { icon: 'FaSpa', text: 'Wellness Center' }
  ],
  contact: {
    name: 'Villa Sales Team',
    position: 'Villa Specialist',
    company: 'Meraas',
    phone: '+971XXXXXXXXX',
    email: 'villas@meraas.ae'
  },
  images: [
    '/assets/residential/meraas/the-acres.jpg',
    '/assets/residential/meraas/the-acres-1.jpg',
    '/assets/residential/meraas/the-acres-2.jpg',
    '/assets/residential/meraas/the-acres-3.jpg',
    '/assets/residential/meraas/the-acres-4.jpg',
    '/assets/residential/meraas/the-acres-5.jpg'
  ]
},

'jumeirah-asora-bay-meraas': {
  title: 'Jumeirah Asora Bay',
  location: 'La Mer, Dubai, UAE',
  type: '4-6BR Penthouses',
  builder: 'Meraas',
  floors: 'Ultra-Luxury Beachfront',
  category: 'Residential',
  bedrooms: '4-6 BR',
  bathrooms: '4-6',
  area: 'Penthouses',
  isFeatured: true,
  isLuxury: true,
  description: 'Jumeirah Asora Bay presents ultra-luxury penthouses with unparalleled beachfront living at La Mer. These exclusive residences feature private pools, panoramic sea views, and bespoke interiors.',
  ellingtonPricing: {
    startingPrice: {
      aed: 49000000
    },
    paymentPlan: 'Bespoke Payment Plan',
    highlights: 'Ultra-luxury beachfront penthouses'
  },
  specialFeatures: [
    'Starting from AED 49M',
    'Bespoke Payment Plans',
    'Ultra-luxury penthouses',
    'Private pools',
    'Beachfront location',
    'Panoramic sea views',
    'Exclusive amenities',
    'La Mer lifestyle'
  ],
  features: [
    { icon: 'FaCrown', text: 'Ultra Luxury' },
    { icon: 'FaUmbrellaBeach', text: 'Private Beach' },
    { icon: 'FaSwimmingPool', text: 'Private Pools' },
    { icon: 'FaSpa', text: 'Luxury Spa' },
    { icon: 'FaDumbbell', text: 'Private Gym' },
    { icon: 'FaCar', text: 'Valet Service' },
    { icon: 'FaShieldAlt', text: 'Concierge 24/7' },
    { icon: 'FaUtensils', text: 'Fine Dining' }
  ],
  contact: {
    name: 'Ultra Luxury Team',
    position: 'Luxury Specialist',
    company: 'Meraas',
    phone: '+971XXXXXXXXX',
    email: 'ultraluxury@meraas.ae'
  },
  images: [
    '/assets/residential/meraas/asora-bay.jpg',
    '/assets/residential/meraas/asora-bay-1.jpg',
    '/assets/residential/meraas/asora-bay-2.jpg',
    '/assets/residential/meraas/asora-bay-3.jpg',
    '/assets/residential/meraas/asora-bay-4.jpg',
    '/assets/residential/meraas/asora-bay-5.jpg'
  ]
},

'atelis-d3-meraas': {
  title: 'Atélis at d3',
  location: 'Dubai Design District, Dubai, UAE',
  type: '1-4BR Apartments & Penthouses',
  builder: 'Meraas',
  floors: 'Mid-Rise',
  category: 'Residential',
  bedrooms: '1-4 BR',
  bathrooms: '1-4',
  area: 'Multiple Units',
  isFeatured: false,
  description: 'Atélis at d3 offers contemporary living in the heart of Dubai Design District. This modern development features stylish apartments and penthouses with creative-inspired design and urban amenities.',
  ellingtonPricing: {
    startingPrice: {
      aed: 2100000
    },
    paymentPlan: 'Flexible Payment Plan',
    highlights: 'Contemporary design district living'
  },
  specialFeatures: [
    'Starting from AED 2.1M',
    'Flexible Payment Plan',
    'Dubai Design District',
    '1-4 BR apartments',
    'Modern architecture',
    'Creative community',
    'Urban lifestyle',
    'd3 location'
  ],
  features: [
    { icon: 'FaBuilding', text: 'Modern Design' },
    { icon: 'FaSwimmingPool', text: 'Swimming Pool' },
    { icon: 'FaDumbbell', text: 'Fitness Center' },
    { icon: 'FaCar', text: 'Covered Parking' },
    { icon: 'FaShieldAlt', text: '24/7 Security' },
    { icon: 'FaCity', text: 'Design District' },
    { icon: 'FaShoppingBag', text: 'Retail Access' }
  ],
  contact: {
    name: 'Sales Team',
    position: 'Property Consultant',
    company: 'Meraas',
    phone: '+971XXXXXXXXX',
    email: 'sales@meraas.ae'
  },
  images: [
    '/assets/residential/meraas/atelis-d3.jpg',
    '/assets/residential/meraas/atelis-d3-1.jpg',
    '/assets/residential/meraas/atelis-d3-2.jpg',
    '/assets/residential/meraas/atelis-d3-3.jpg',
    '/assets/residential/meraas/atelis-d3-4.jpg',
    '/assets/residential/meraas/atelis-d3-5.jpg'
  ]
},

'jumeirah-residences-emirates-towers-meraas': {
  title: 'Jumeirah Residences Emirates Towers',
  location: 'Trade Centre 2, Dubai, UAE',
  type: '1-4BR Luxury Apartments',
  builder: 'Meraas',
  floors: 'High-Rise',
  category: 'Residential',
  bedrooms: '1-4 BR',
  bathrooms: '1-4',
  area: 'Luxury Tower',
  isFeatured: true,
  description: 'Jumeirah Residences Emirates Towers offers prestigious living in the heart of Dubai with iconic skyline views. This luxury development features world-class amenities and prime connectivity.',
  ellingtonPricing: {
    startingPrice: {
      aed: 3510000
    },
    paymentPlan: 'Flexible Payment Plan',
    highlights: 'Prestigious Emirates Towers location'
  },
  specialFeatures: [
    'Starting from AED 3.51M',
    'Flexible Payment Plan',
    'Emirates Towers',
    'Iconic location',
    'Skyline views',
    'Luxury amenities',
    'Prime connectivity',
    'Trade Centre'
  ],
  features: [
    { icon: 'FaBuilding', text: 'Iconic Tower' },
    { icon: 'FaCity', text: 'Skyline Views' },
    { icon: 'FaSwimmingPool', text: 'Luxury Pool' },
    { icon: 'FaDumbbell', text: 'Premium Gym' },
    { icon: 'FaSpa', text: 'Spa & Wellness' },
    { icon: 'FaCar', text: 'Valet Parking' },
    { icon: 'FaShieldAlt', text: 'Concierge Services' }
  ],
  contact: {
    name: 'Luxury Sales Team',
    position: 'Senior Consultant',
    company: 'Meraas',
    phone: '+971XXXXXXXXX',
    email: 'luxury@meraas.ae'
  },
  images: [
    '/assets/residential/meraas/emirates-towers.jpg',
    '/assets/residential/meraas/emirates-towers-1.jpg',
    '/assets/residential/meraas/emirates-towers-2.jpg',
    '/assets/residential/meraas/emirates-towers-3.jpg',
    '/assets/residential/meraas/emirates-towers-4.jpg',
    '/assets/residential/meraas/emirates-towers-5.jpg'
  ]
},

'city-walk-meraas': {
  title: 'City Walk',
  location: 'Jumeirah, Dubai, UAE',
  type: '1-4BR Apartments',
  builder: 'Meraas',
  floors: 'Mixed-Use Development',
  category: 'Residential',
  bedrooms: '1-4 BR',
  bathrooms: '1-4',
  area: 'Urban Development',
  isFeatured: false,
  description: 'City Walk offers vibrant urban living with retail, dining, and entertainment at your doorstep. This mixed-use development features modern apartments in the heart of Jumeirah.',
  ellingtonPricing: {
    startingPrice: {
      aed: 2800000
    },
    paymentPlan: 'Flexible Payment Plan',
    highlights: 'Urban lifestyle hub'
  },
  specialFeatures: [
    'Starting from AED 2.8M',
    'Flexible Payment Plan',
    'Mixed-use community',
    'Retail & dining',
    'Entertainment options',
    'Jumeirah location',
    'Urban lifestyle',
    'Walkable community'
  ],
  features: [
    { icon: 'FaShoppingBag', text: 'Shopping Mall' },
    { icon: 'FaUtensils', text: 'Dining Options' },
    { icon: 'FaSwimmingPool', text: 'Swimming Pool' },
    { icon: 'FaDumbbell', text: 'Fitness Center' },
    { icon: 'FaCar', text: 'Covered Parking' },
    { icon: 'FaShieldAlt', text: '24/7 Security' },
    { icon: 'FaCity', text: 'Urban Living' }
  ],
  contact: {
    name: 'Sales Team',
    position: 'Property Consultant',
    company: 'Meraas',
    phone: '+971XXXXXXXXX',
    email: 'sales@meraas.ae'
  },
  images: [
    '/assets/residential/meraas/city-walk.jpg',
    '/assets/residential/meraas/city-walk-1.jpg',
    '/assets/residential/meraas/city-walk-2.jpg',
    '/assets/residential/meraas/city-walk-3.jpg',
    '/assets/residential/meraas/city-walk-4.jpg',
    '/assets/residential/meraas/city-walk-5.jpg'
  ]
}
,
'la-mer-beachfront-meraas': {
  title: 'Solaya La Mer',
  location: 'La Mer, Jumeirah, Dubai, UAE',
  type: '2-5BR Ultra-Luxury Beachfront Apartments',
  builder: 'Meraas & Brookfield',
  floors: '9 Buildings',
  category: 'Residential',
  bedrooms: '2-5 BR',
  bathrooms: '2-5',
  area: '2,308-7,643 sq.ft',
  isFeatured: true,
  isLuxury: true,
  description: 'Solaya La Mer offers ultra-luxury beachfront living with 234 exclusive residences across 9 buildings. Direct beach access, stunning Arabian Gulf views, and world-class amenities define this prestigious development. 10-year UAE Golden Visa eligible.',
  ellingtonPricing: {
    startingPrice: {
      aed: 14200000
    },
    paymentPlan: '20% EOI, 60/40 Payment Plan',
    highlights: 'Ultra-luxury beachfront with Golden Visa'
  },
  specialFeatures: [
    'Starting from AED 14.2M',
    '20% EOI, 60/40 Payment Plan',
    'Direct beach access',
    'Only 234 residences',
    '10-Year Golden Visa eligible',
    '9 exclusive buildings',
    'Private beach',
    'Handover Q2 2029'
  ],
  features: [
    { icon: 'FaUmbrellaBeach', text: 'Private Beach Access' },
    { icon: 'FaSwimmingPool', text: 'Infinity Pool' },
    { icon: 'FaSpa', text: 'Luxury Spa & Wellness' },
    { icon: 'FaDumbbell', text: 'Premium Gym' },
    { icon: 'FaUtensils', text: 'Beachfront Dining' },
    { icon: 'FaCar', text: 'Valet Parking' },
    { icon: 'FaShieldAlt', text: 'Concierge Services' },
    { icon: 'FaCrown', text: 'Golden Visa Eligible' }
  ],
  contact: {
    name: 'Ultra Luxury Sales Team',
    position: 'Senior Consultant',
    company: 'Meraas & Brookfield',
    phone: '+971XXXXXXXXX',
    email: 'solaya@meraas.ae'
  },
  images: [
    '/assets/residential/meraas/la-mer.jpg',
    '/assets/residential/meraas/la-mer-1.jpg',
    '/assets/residential/meraas/la-mer-2.jpg',
    '/assets/residential/meraas/la-mer-3.jpg',
    '/assets/residential/meraas/la-mer-4.jpg',
    '/assets/residential/meraas/la-mer-5.jpg'
  ]
},

'green-ville-emaar': {
  title: 'Greenville',
  location: 'Emaar South, Dubai, UAE',
  type: '3 & 4BR Townhouses',
  builder: 'Emaar Properties',
  floors: 'G+2 Townhouses',
  category: 'Residential',
  bedrooms: '3-4 BR',
  bathrooms: '4-5',
  area: '3,071-3,513 sq.ft',
  isFeatured: false,
  description: 'Greenville by Emaar offers spacious G+2 townhouses in Emaar South with modern design and premium amenities. Strategic location with excellent connectivity and family-friendly community.',
  ellingtonPricing: {
    startingPrice: {
      aed: 3200000
    },
    paymentPlan: '80/20 Payment Plan (10% Booking)',
    highlights: 'Spacious townhouses in Emaar South'
  },
  specialFeatures: [
    'Starting from AED 3.2M',
    '80/20 Payment Plan',
    '10% Down Payment',
    '3-4 bedroom townhouses',
    'Emaar South location',
    'G+2 design',
    'Family community',
    'Handover Q1 2029'
  ],
  features: [
    { icon: 'FaHome', text: 'Spacious Townhouses' },
    { icon: 'FaSwimmingPool', text: 'Swimming Pool' },
    { icon: 'FaDumbbell', text: 'Fitness Center' },
    { icon: 'FaCar', text: 'Covered Parking' },
    { icon: 'FaShieldAlt', text: '24/7 Security' },
    { icon: 'FaChild', text: 'Kids Play Area' },
    { icon: 'FaTree', text: 'Green Spaces' }
  ],
  contact: {
    name: 'Sales Team',
    position: 'Property Consultant',
    company: 'Emaar Properties',
    phone: '+971XXXXXXXXX',
    email: 'sales@emaar.ae'
  },
  media: [
    {
      type: 'video',
      src: '/assets/residential/emaar/green-ville-video.mp4',
      poster: '/assets/residential/emaar/green-ville.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/emaar/green-ville.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/emaar/green-ville-1.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/emaar/green-ville-2.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/emaar/green-ville-3.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/emaar/green-ville-4.jpg'
    }
  ]
},

'velora-2-emaar': {
  title: 'Velora 2',
  location: 'The Valley, Dubai, UAE',
  type: '3 & 4BR Townhouses',
  builder: 'Emaar Properties',
  floors: 'Townhouse Community',
  category: 'Residential',
  bedrooms: '3-4 BR',
  bathrooms: '3-5',
  area: '2,456-2,731 sq.ft',
  isFeatured: false,
  description: 'Velora 2 continues the legacy of premium townhouse living in The Valley with elegant design and modern amenities. Well-connected location with serene environment perfect for families.',
  ellingtonPricing: {
    startingPrice: {
      aed: 2930000
    },
    paymentPlan: '80/20 Payment Plan (10% Booking)',
    highlights: 'Elegant townhouses in The Valley'
  },
  specialFeatures: [
    'Starting from AED 2.93M',
    '80/20 Payment Plan',
    '10% Down Payment',
    'The Valley location',
    '3-4 bedroom townhouses',
    'Modern design',
    'Natural landscape',
    'Handover Q3 2028'
  ],
  features: [
    { icon: 'FaHome', text: 'Modern Townhouses' },
    { icon: 'FaSwimmingPool', text: 'Swimming Pool' },
    { icon: 'FaDumbbell', text: 'Fitness Center' },
    { icon: 'FaTree', text: 'Green Spaces' },
    { icon: 'FaCar', text: 'Covered Parking' },
    { icon: 'FaShieldAlt', text: '24/7 Security' },
    { icon: 'FaChild', text: 'Family Community' }
  ],
  contact: {
    name: 'Sales Team',
    position: 'Property Consultant',
    company: 'Emaar Properties',
    phone: '+971XXXXXXXXX',
    email: 'sales@emaar.ae'
  },
  images: [
    '/assets/residential/emaar/velora-2.jpg',
    '/assets/residential/emaar/velora-2-1.jpg',
    '/assets/residential/emaar/velora-2-2.jpg',
    '/assets/residential/emaar/velora-2-3.jpg',
    '/assets/residential/emaar/velora-2-4.jpg'
  ]
},

'avena-emaar': {
  title: 'Avena',
  location: 'The Valley 2, Al-Ain Road, Dubai, UAE',
  type: '4BR Luxury Villas',
  builder: 'Emaar Properties',
  floors: 'Ground + 2 Floors',
  category: 'Residential',
  bedrooms: '4 BR',
  bathrooms: '5',
  area: '3,685 sq.ft built-up | 3,082-5,364 sq.ft plot',
  isFeatured: false,
  description: 'Avena by Emaar offers premium 4-bedroom G+2 villas in The Valley 2 with spacious living areas and generous plot sizes. Contemporary design with world-class amenities in a prime Al-Ain Road location.',
  ellingtonPricing: {
    startingPrice: {
      aed: 4360000
    },
    paymentPlan: '80/20 Payment Plan (10% EOI)',
    highlights: 'Premium 4BR villas in The Valley 2'
  },
  specialFeatures: [
    'Starting from AED 4.36M',
    '80/20 Payment Plan',
    '10% EOI Booking',
    '4-bedroom villas',
    'G+2 design',
    'Large plot sizes',
    'Al-Ain Road location',
    'Handover 2028'
  ],
  features: [
    { icon: 'FaHome', text: 'Luxury Villas' },
    { icon: 'FaSwimmingPool', text: 'Swimming Pool' },
    { icon: 'FaDumbbell', text: 'Fitness Center' },
    { icon: 'FaTree', text: 'Private Gardens' },
    { icon: 'FaCar', text: 'Private Parking' },
    { icon: 'FaShieldAlt', text: 'Gated Security' },
    { icon: 'FaChild', text: 'Kids Play Area' }
  ],
  contact: {
    name: 'Villa Sales Team',
    position: 'Property Consultant',
    company: 'Emaar Properties',
    phone: '+971XXXXXXXXX',
    email: 'sales@emaar.ae'
  },
  images: [
    '/assets/residential/emaar/avena.jpg',
    '/assets/residential/emaar/avena-1.jpg',
    '/assets/residential/emaar/avena-2.jpg',
    '/assets/residential/emaar/avena-3.jpg',
    '/assets/residential/emaar/avena-4.jpg'
  ]
},

'green-ridge-emaar': {
  title: 'Green Ridge',
  location: 'Dubai, UAE',
  type: 'Apartments',
  builder: 'Emaar Properties',
  floors: 'Mid-Rise',
  category: 'Residential',
  bedrooms: '1-3 BR',
  bathrooms: '1-3',
  area: 'Multiple Units',
  isFeatured: false,
  description: 'Green Ridge by Emaar brings nature-inspired living with lush green surroundings and modern architecture.',
  ellingtonPricing: {
    startingPrice: {
      aed: 1550000
    },
    paymentPlan: 'Flexible Payment Plan',
    highlights: 'Nature-inspired living'
  },
  specialFeatures: [
    'Starting from AED 1.55M',
    'Flexible Payment Plan',
    'Green surroundings',
    'Modern architecture',
    'Premium amenities'
  ],
  features: [
    { icon: 'FaSwimmingPool', text: 'Swimming Pool' },
    { icon: 'FaDumbbell', text: 'Fitness Center' },
    { icon: 'FaCar', text: 'Covered Parking' },
    { icon: 'FaShieldAlt', text: '24/7 Security' },
    { icon: 'FaChild', text: 'Kids Play Area' },
    { icon: 'FaTree', text: 'Green Spaces' }
  ],
  contact: {
    name: 'Sales Team',
    position: 'Property Consultant',
    company: 'Emaar Properties',
    phone: '+971XXXXXXXXX',
    email: 'sales@emaar.ae'
  },
  images: [
    '/assets/residential/emaar/green-ridge.jpg',
    '/assets/residential/emaar/green-ridge-1.jpg',
    '/assets/residential/emaar/green-ridge-2.jpg',
    '/assets/residential/emaar/green-ridge-3.jpg'
  ]
},

'vida-emaar': {
  title: 'Vida Residences Dubai Hills Estate',
  location: 'Dubai Hills Estate, Dubai, UAE',
  type: '1-3BR Apartments & Townhouses',
  builder: 'Emaar Properties',
  floors: 'High-Rise',
  category: 'Residential',
  bedrooms: '1-3 BR',
  bathrooms: '1-3',
  area: 'Multiple Units',
  isFeatured: false,
  description: 'Vida Residences offers hotel-inspired lifestyle living with premium amenities and services in Dubai Hills Estate. Contemporary design with resort-style facilities.',
  ellingtonPricing: {
    startingPrice: {
      aed: 1700000
    },
    paymentPlan: '90/10 Payment Plan (10% Booking)',
    highlights: 'Hotel-inspired lifestyle living'
  },
  specialFeatures: [
    'Starting from AED 1.7M',
    '90/10 Payment Plan',
    '10% Booking Fee',
    'Hotel-inspired amenities',
    'Dubai Hills Estate',
    'Contemporary design',
    'Handover Q3 2028'
  ],
  features: [
    { icon: 'FaSwimmingPool', text: 'Swimming Pool' },
    { icon: 'FaDumbbell', text: 'Fitness Center' },
    { icon: 'FaCar', text: 'Covered Parking' },
    { icon: 'FaShieldAlt', text: '24/7 Security' },
    { icon: 'FaSpa', text: 'Spa & Wellness' },
    { icon: 'FaUtensils', text: 'Hotel Services' }
  ],
  contact: {
    name: 'Sales Team',
    position: 'Property Consultant',
    company: 'Emaar Properties',
    phone: '+971XXXXXXXXX',
    email: 'sales@emaar.ae'
  },
  images: [
    '/assets/residential/emaar/vida.jpg',
    '/assets/residential/emaar/vida-1.jpg',
    '/assets/residential/emaar/vida-2.jpg',
    '/assets/residential/emaar/vida-3.jpg'
  ]
},

'al-marjan-island-emaar': {
  title: 'Al Marjan Island',
  location: 'Al Marjan Island, Ras Al Khaimah, UAE',
  type: 'Waterfront Apartments',
  builder: 'Emaar Properties',
  floors: 'High-Rise',
  category: 'Residential',
  bedrooms: '1-4 BR',
  bathrooms: '1-4',
  area: 'Multiple Units',
  isFeatured: true,
  description: 'Al Marjan Island by Emaar presents exclusive waterfront living with panoramic views, private beach access, and world-class amenities on a prestigious island location.',
  ellingtonPricing: {
    startingPrice: {
      aed: 2500000
    },
    paymentPlan: 'Flexible Payment Plan',
    highlights: 'Exclusive island living with beach access'
  },
  specialFeatures: [
    'Starting from AED 2.5M',
    'Flexible Payment Plan',
    'Waterfront location',
    'Private beach access',
    'Island living',
    'Panoramic views'
  ],
  features: [
    { icon: 'FaUmbrellaBeach', text: 'Private Beach Access' },
    { icon: 'FaSwimmingPool', text: 'Infinity Pool' },
    { icon: 'FaDumbbell', text: 'Fitness Center' },
    { icon: 'FaSpa', text: 'Spa & Wellness' },
    { icon: 'FaCar', text: 'Covered Parking' },
    { icon: 'FaShieldAlt', text: '24/7 Security' }
  ],
  contact: {
    name: 'Luxury Sales Team',
    position: 'Senior Consultant',
    company: 'Emaar Properties',
    phone: '+971XXXXXXXXX',
    email: 'luxury@emaar.ae'
  },
  images: [
    '/assets/residential/emaar/al-marjan-island.jpg',
    '/assets/residential/emaar/al-marjan-island-1.jpg',
    '/assets/residential/emaar/al-marjan-island-2.jpg',
    '/assets/residential/emaar/al-marjan-island-3.jpg'
  ]
},

'tonino-lamborghini-al-marjan': {
  title: 'Tonino Lamborghini Residences',
  location: 'Al Marjan Island, Ras Al Khaimah, UAE',
  type: 'Studios to 3BR | Villas | Mansions',
  builder: 'BNW Developments',
  floors: 'G + 15 Floors',
  category: 'Residential',
  bedrooms: 'Studios to 3 BR + Villas',
  bathrooms: 'Varies by unit',
  area: '378 Total Units',
  isFeatured: true,
  isLuxury: true,
  mapUrl: 'https://maps.app.goo.gl/YJyshFcpF7zRhLJL8?g_st=iw',
  description: 'Tonino Lamborghini Residences brings iconic luxury branded living to Al Marjan Island near the future Wynn Casino. Ultra-luxury sea front apartments, exclusive villas, and prestigious mansions with Golden Visa eligibility.',
  ellingtonPricing: {
    startingPrice: {
      aed: 1690000
    },
    paymentPlan: '10% Down Payment',
    highlights: 'Near Future Wynn Casino Resort'
  },
  specialFeatures: [
    'Starting from AED 1.69M',
    '10% Down Payment',
    'Near Future Wynn Casino',
    'Sea Front Location',
    'Fully Furnished Units',
    'Golden Visa eligible',
    '378 total units',
    'Handover Q4 2028'
  ],
  features: [
    { icon: 'FaSwimmingPool', text: 'Infinity Pool with Sea Views' },
    { icon: 'FaDumbbell', text: 'State-of-the-art Fitness Center' },
    { icon: 'FaUmbrellaBeach', text: 'Private Beach Access' },
    { icon: 'FaUtensils', text: 'Fine Dining Restaurants' },
    { icon: 'FaDice', text: 'Near Wynn Casino Resort' },
    { icon: 'FaCar', text: 'Covered Parking' },
    { icon: 'FaShieldAlt', text: '24/7 Security & Concierge' },
    { icon: 'FaChild', text: 'Kids Play Area' },
    { icon: 'FaSpa', text: 'Luxury Spa & Wellness Center' },
    { icon: 'FaShoppingBag', text: 'Retail Shopping Boulevard' }
  ],
  contact: {
    name: 'Khushboo Advani',
    position: 'Sales Manager',
    company: 'BNW Developments',
    phone: '+971XXXXXXXXX',
    email: 'sales@bnwdevelopments.com'
  },
  media: [
    {
      type: 'video',
      src: '/assets/residential/tonino-lamborghini-al-marjan/main.mp4',
      poster: '/assets/residential/tonino-lamborghini-al-marjan/main.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/tonino-lamborghini-al-marjan/image1.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/tonino-lamborghini-al-marjan/image2.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/tonino-lamborghini-al-marjan/image3.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/tonino-lamborghini-al-marjan/image4.jpg'
    }
  ]
},

'the-hillgate-dubai-silicon-oasis': {
  title: 'The Hillgate',
  location: 'Dubai Silicon Oasis, Dubai, UAE',
  type: 'Studios & 1-4BR Apartments',
  builder: 'Ellington Properties',
  floors: 'Mid-Rise',
  category: 'Residential',
  bedrooms: 'Studio-4 BR',
  bathrooms: '1-4',
  area: 'Studios to 4BR apartments',
  isFeatured: false,
  description: 'The Hillgate offers excellent value with strong rental demand in Dubai Silicon Oasis. Modern studios to 4-bedroom apartments designed for comfortable living with contemporary finishes and prime connectivity.',
  ellingtonPricing: {
    startingPrice: {
      aed: 1300000
    },
    paymentPlan: '70/30 Payment Plan (20% Down)',
    highlights: 'Excellent value & strong rental demand'
  },
  specialFeatures: [
    'Starting from AED 1.3M',
    '70/30 Payment Plan',
    '20% Down Payment',
    'Strong rental demand area',
    'Modern design & finishes',
    'Dubai Silicon Oasis',
    'Service charge AED 14/sqft',
    'Handover Q4 2027'
  ],
  features: [
    { icon: 'FaHome', text: 'Modern Design' },
    { icon: 'FaSwimmingPool', text: 'Swimming Pool' },
    { icon: 'FaDumbbell', text: 'Fitness Center' },
    { icon: 'FaCar', text: 'Covered Parking' },
    { icon: 'FaShieldAlt', text: '24/7 Security' },
    { icon: 'FaChild', text: 'Kids Play Area' },
    { icon: 'FaBuilding', text: 'Community Clubhouse' },
    { icon: 'FaStar', text: 'High Rental Yields' }
  ],
  contact: {
    name: 'Sales Team',
    position: 'Property Consultant',
    company: 'Ellington Properties',
    phone: '+971XXXXXXXXX',
    email: 'sales@ellington.ae'
  },
  media: [
    {
      type: 'video',
      src: '/assets/residential/ellington/the-hillgate-video.mp4',
      poster: '/assets/residential/ellington/the-hillgate.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/the-hillgate.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/the-hillgate-1.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/the-hillgate-2.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/the-hillgate-4.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/the-hillgate-5.jpg'
    }
  ]
},

'riverton-house-meydan-horizon': {
  title: 'Riverton House',
  location: 'Meydan Horizon, Dubai, UAE',
  type: '1 & 2BR Residences',
  builder: 'Ellington Properties',
  floors: 'High-Rise',
  category: 'Residential',
  bedrooms: '1-2 BR',
  bathrooms: '1-2',
  area: '1 & 2BR residences',
  isFeatured: false,
  description: 'Riverton House is located in a prime future growth location at Meydan Horizon. Perfect for investors and first-time buyers with modern amenities and flexible payment plans.',
  ellingtonPricing: {
    startingPrice: {
      aed: 2170000
    },
    paymentPlan: '70/30 Payment Plan',
    highlights: 'Prime future growth location'
  },
  specialFeatures: [
    'Starting from AED 2.17M',
    '70/30 Payment Plan',
    'Prime future growth location',
    'Perfect for investors',
    'Ideal for first-time buyers',
    'Meydan Horizon',
    'Modern design & finishes'
  ],
  features: [
    { icon: 'FaHome', text: 'Contemporary Design' },
    { icon: 'FaSwimmingPool', text: 'Infinity Pool' },
    { icon: 'FaDumbbell', text: 'Gym' },
    { icon: 'FaCar', text: 'Parking' },
    { icon: 'FaShieldAlt', text: 'Security' }
  ],
  contact: {
    name: 'Sales Team',
    position: 'Property Consultant',
    company: 'Ellington Properties',
    phone: '+971XXXXXXXXX',
    email: 'sales@ellington.ae'
  },
  media: [
    {
      type: 'video',
      src: '/assets/residential/ellington/riverton-house-video.mp4',
      poster: '/assets/residential/ellington/riverton-house.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/riverton-house.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/riverton-house-1.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/riverton-house-2.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/riverton-house-3.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/riverton-house-4.jpg'
    }
  ]
},

'belgravia-gardens-dubailand': {
  title: 'Belgravia Gardens',
  location: 'Dubailand, Dubai, UAE',
  type: 'Spacious 2 & 3BR Homes',
  builder: 'Ellington Properties',
  floors: 'Low-Rise',
  category: 'Residential',
  bedrooms: '2-3 BR',
  bathrooms: '2-3',
  area: 'Spacious 2 & 3BR homes',
  isFeatured: false,
  description: 'Family-oriented community in Dubailand offering spacious homes with modern amenities and green spaces. Perfect for families seeking a peaceful lifestyle with excellent connectivity.',
  ellingtonPricing: {
    startingPrice: {
      aed: 2450000
    },
    paymentPlan: '70/30 Payment Plan',
    highlights: 'Family-oriented community'
  },
  specialFeatures: [
    'Starting from AED 2.45M',
    '70/30 Payment Plan',
    'Family-oriented community',
    'Spacious living areas',
    'Green spaces and parks',
    'Dubailand location',
    'Child-friendly amenities'
  ],
  features: [
    { icon: 'FaChild', text: 'Family Community' },
    { icon: 'FaSwimmingPool', text: 'Swimming Pool' },
    { icon: 'FaDumbbell', text: 'Fitness Center' },
    { icon: 'FaChild', text: 'Kids Play Areas' },
    { icon: 'FaCar', text: 'Covered Parking' },
    { icon: 'FaBuilding', text: 'Community Center' },
    { icon: 'FaShieldAlt', text: '24/7 Security' },
    { icon: 'FaTree', text: 'Green Spaces' }
  ],
  contact: {
    name: 'Sales Team',
    position: 'Property Consultant',
    company: 'Ellington Properties',
    phone: '+971XXXXXXXXX',
    email: 'sales@ellington.ae'
  },
  media: [
    {
      type: 'video',
      src: '/assets/residential/ellington/belgravia-gardens-video.mp4',
      poster: '/assets/residential/ellington/belgravia-gardens.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/belgravia-gardens.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/belgravia-gardens-1.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/belgravia-gardens-2.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/belgravia-gardens-3.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/belgravia-gardens-4.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/belgravia-gardens-5.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/belgravia-gardens-6.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/belgravia-gardens-7.jpg'
    }
  ]
},

'one-river-point-business-bay': {
  title: 'One River Point',
  location: 'Business Bay, Dubai, UAE',
  type: 'Studios to 4BR Units',
  builder: 'Ellington Properties',
  floors: '50+ Floor Tower',
  category: 'Residential',
  bedrooms: 'Studio-4 BR',
  bathrooms: '1-4',
  area: '488-4,972 sq.ft',
  isFeatured: false,
  description: 'Stunning canal views and central location in the heart of Business Bay. Premium living with world-class amenities and breathtaking water views. Approximately 450 units across 50+ floors.',
  ellingtonPricing: {
    startingPrice: {
      aed: 1482828
    },
    paymentPlan: '70/30 Payment Plan (20% Down)',
    highlights: 'Canal views & central location'
  },
  specialFeatures: [
    'Starting from AED 1.48M',
    '70/30 Payment Plan',
    '20% Down Payment',
    'Stunning canal views',
    'Central Business Bay',
    '50+ floor tower',
    '450 luxury units',
    'Handover Q2 2027'
  ],
  features: [
    { icon: 'FaCity', text: 'Canal Views' },
    { icon: 'FaSwimmingPool', text: 'Luxury Pool' },
    { icon: 'FaDumbbell', text: 'State-of-art Gym' },
    { icon: 'FaSpa', text: 'Spa & Wellness' },
    { icon: 'FaCar', text: 'Valet Parking' },
    { icon: 'FaShieldAlt', text: 'Concierge Services' }
  ],
  contact: {
    name: 'Sales Team',
    position: 'Property Consultant',
    company: 'Ellington Properties',
    phone: '+971XXXXXXXXX',
    email: 'sales@ellington.ae'
  },
  media: [
    {
      type: 'video',
      src: '/assets/residential/ellington/one-river-point-video.mp4',
      poster: '/assets/residential/ellington/one-river-point.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/one-river-point.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/one-river-point-2.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/one-river-point-3.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/one-river-point-4.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/one-river-point-5.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/one-river-point-6.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/one-river-point-7.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/one-river-point-8.jpg'
    }
  ]
},

'ocean-house-palm-jumeirah': {
  title: 'Ocean House',
  location: 'Palm Jumeirah, Dubai, UAE',
  type: 'Ultra-Luxury 2-6BR Residences',
  builder: 'Ellington Properties',
  floors: 'Exclusive Tower',
  category: 'Residential',
  bedrooms: '2-6 BR',
  bathrooms: '2-6',
  area: '2,049-11,770 sq.ft',
  isFeatured: true,
  isLuxury: true,
  description: 'Iconic beachfront living on the prestigious Palm Jumeirah. Ultra-luxury residences with unparalleled sea views, direct beach access, and world-class amenities including spa, theatre, and fine dining.',
  ellingtonPricing: {
    startingPrice: {
      aed: 9800000
    },
    paymentPlan: '60/40 Payment Plan',
    highlights: 'Iconic beachfront living'
  },
  specialFeatures: [
    'Starting from AED 9.8M',
    '60/40 Payment Plan',
    'Iconic beachfront living',
    'Palm Jumeirah location',
    'Ultra-luxury residences',
    'Direct beach access',
    '6BR from AED 77.69M',
    'Handover Q4 2026'
  ],
  features: [
    { icon: 'FaUmbrellaBeach', text: 'Private Beach' },
    { icon: 'FaSwimmingPool', text: 'Infinity Pools' },
    { icon: 'FaSpa', text: 'Luxury Spa' },
    { icon: 'FaDumbbell', text: 'Premium Gym' },
    { icon: 'FaUtensils', text: 'Fine Dining' },
    { icon: 'FaFilm', text: 'Private Theatre' },
    { icon: 'FaCar', text: 'Valet Service' },
    { icon: 'FaShieldAlt', text: 'Concierge & Security' }
  ],
  contact: {
    name: 'Luxury Sales Team',
    position: 'Senior Consultant',
    company: 'Ellington Properties',
    phone: '+971XXXXXXXXX',
    email: 'luxury@ellington.ae'
  },
  media: [
    {
      type: 'video',
      src: '/assets/residential/ellington/ocean-house-video.mp4',
      poster: '/assets/residential/ellington/ocean-house.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/ocean-house.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/ocean-house-1.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/ocean-house-2.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/ocean-house-3.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/ocean-house-4.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/ocean-house-5.jpg'
    }
  ]
},

'playa-del-sol-ras-al-khaimah': {
  title: 'Playa Del Sol',
  location: 'Ras Al Khaimah, UAE',
  type: '2 & 3BR Beachfront Homes',
  builder: 'Ellington Properties',
  floors: 'Beachfront Development',
  category: 'Residential',
  bedrooms: '2-3 BR',
  bathrooms: '2-3',
  area: '2 & 3BR beachfront homes',
  isFeatured: false,
  description: 'High holiday-rental potential in beautiful Ras Al Khaimah. Beachfront homes perfect for investment and vacation living with stunning sea views.',
  ellingtonPricing: {
    startingPrice: {
      aed: 3800000
    },
    paymentPlan: '60/40 Payment Plan',
    highlights: 'High holiday-rental potential'
  },
  specialFeatures: [
    'Starting from AED 3.8M',
    '60/40 Payment Plan',
    'High holiday-rental potential',
    'Beachfront location',
    'Perfect for investment',
    'Ras Al Khaimah',
    'Vacation home lifestyle'
  ],
  features: [
    { icon: 'FaUmbrellaBeach', text: 'Beach Access' },
    { icon: 'FaSwimmingPool', text: 'Beach Pool' },
    { icon: 'FaUtensils', text: 'Beach Restaurant' },
    { icon: 'FaCar', text: 'Parking' },
    { icon: 'FaShieldAlt', text: 'Security' },
    { icon: 'FaDumbbell', text: 'Fitness Center' }
  ],
  contact: {
    name: 'Sales Team',
    position: 'Property Consultant',
    company: 'Ellington Properties',
    phone: '+971XXXXXXXXX',
    email: 'sales@ellington.ae'
  },
  media: [
    {
      type: 'video',
      src: '/assets/residential/ellington/playa-del-sol-video.mp4',
      poster: '/assets/residential/ellington/playa-del-sol.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/playa-del-sol.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/playa-del-sol-1.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/playa-del-sol-2.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/playa-del-sol-3.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/playa-del-sol-4.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/playa-del-sol-5.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/playa-del-sol-6.jpg'
    }
  ]
},

'costa-mare-al-marjan': {
  title: 'Costa Mare',
  location: 'Al Marjan Island, Ras Al Khaimah, UAE',
  type: '1-4BR Beachfront Apartments',
  builder: 'Ellington Properties',
  floors: '4 Towers',
  category: 'Residential',
  bedrooms: '1-4 BR',
  bathrooms: '1-4',
  area: '900+ Residences',
  isFeatured: true,
  description: 'Costa Mare brings luxurious beachfront living to Al Marjan Island with 900+ residences across four elegant towers. Located near the upcoming Wynn Casino, this development offers private beach access and world-class amenities with stunning sea views.',
  ellingtonPricing: {
    startingPrice: {
      aed: 2201779
    },
    paymentPlan: '70/30 Payment Plan (20% Down)',
    highlights: 'Private beach access & near Wynn Casino'
  },
  specialFeatures: [
    'Starting from AED 2.2M',
    '70/30 Payment Plan',
    '20% Down Payment',
    'Private beach access',
    'Near Wynn Casino Resort',
    '900+ luxury residences',
    '4 beachfront towers',
    'Handover September 2028'
  ],
  features: [
    { icon: 'FaUmbrellaBeach', text: 'Private Beach Access' },
    { icon: 'FaDice', text: 'Near Wynn Casino' },
    { icon: 'FaSwimmingPool', text: 'Infinity Pools' },
    { icon: 'FaDumbbell', text: 'State-of-art Gym' },
    { icon: 'FaSpa', text: 'Spa & Wellness Center' },
    { icon: 'FaCar', text: 'Covered Parking' },
    { icon: 'FaShieldAlt', text: '24/7 Security & Concierge' },
    { icon: 'FaChild', text: 'Kids Play Area' },
    { icon: 'FaUtensils', text: 'Beachfront Dining' }
  ],
  contact: {
    name: 'Sales Team',
    position: 'Property Consultant',
    company: 'Ellington Properties',
    phone: '+971XXXXXXXXX',
    email: 'sales@ellington.ae'
  },
  media: [
    {
      type: 'video',
      src: '/assets/residential/ellington/costa-mare-video.mp4',
      poster: '/assets/residential/ellington/costa-mare.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/costa-mare.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/costa-mare-1.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/costa-mare-2.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/costa-mare-3.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/costa-mare-5.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/costa-mare-6.jpg'
    }
  ]
}
,'eltiera-views-jumeirah-islands': {
  title: 'Eltiera Views',
  location: 'Jumeirah Islands, Dubai, UAE',
  type: '1-4BR Apartments & Penthouses',
  builder: 'Ellington Properties',
  floors: '4 Towers | G+3P+26 Floors',
  category: 'Residential',
  bedrooms: '1-4 BR',
  bathrooms: '1-4',
  area: '1,180 Units | 801-5,985 sq.ft',
  isFeatured: false,
  description: 'Eltiera Views offers luxury island living in Jumeirah Islands with 1,180 residences across four 26-storey towers. Enjoy breathtaking lake and JLT skyline views, lush landscaping, and Ellington\'s largest gym with premium amenities.',
  ellingtonPricing: {
    startingPrice: {
      aed: 2200000
    },
    paymentPlan: '70/30 Payment Plan (20% Down)',
    highlights: 'Luxury island living with lake views'
  },
  specialFeatures: [
    'Starting from AED 2.2M',
    '70/30 Payment Plan',
    '20% Down Payment',
    '1,180 total units',
    '4 towers with 26 floors each',
    '1-4 bedroom apartments & penthouses',
    'Stunning lake & JLT views',
    'Handover Q4 2029'
  ],
  features: [
    { icon: 'FaCity', text: 'Lake & Skyline Views' },
    { icon: 'FaSwimmingPool', text: 'Multiple Pools' },
    { icon: 'FaDumbbell', text: 'Largest Ellington Gym' },
    { icon: 'FaSpa', text: 'Vitality Pool & Spa' },
    { icon: 'FaCar', text: 'Covered Parking' },
    { icon: 'FaShieldAlt', text: '24/7 Security' },
    { icon: 'FaChild', text: 'Kids Play Area' },
    { icon: 'FaFilm', text: 'Private Cinema' }
  ],
  contact: {
    name: 'Sales Team',
    position: 'Property Consultant',
    company: 'Ellington Properties',
    phone: '+971XXXXXXXXX',
    email: 'sales@ellington.ae'
  },
  media: [
    {
      type: 'video',
      src: '/assets/residential/ellington/eltiera-views-video.mp4',
      poster: '/assets/residential/ellington/eltiera-views.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/eltiera-views.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/eltiera-views-1.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/eltiera-views-2.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/eltiera-views-3.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/eltiera-views-4.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/eltiera-views-5.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/eltiera-views-6.jpg'
    }
  ]
},

'mercer-house-uptown-dubai': {
  title: 'Mercer House',
  location: 'Uptown Dubai, JLT, UAE',
  type: 'Studios & 1-4BR Apartments',
  builder: 'Ellington Properties',
  floors: '2 Twin Towers',
  category: 'Residential',
  bedrooms: 'Studio-4 BR',
  bathrooms: '1-4',
  area: '325 Residences',
  isFeatured: false,
  description: 'Mercer House brings wellness-focused design to Uptown Dubai in Jumeirah Lakes Towers. Featuring 325 residences across two linked towers, including studios, 1-3 bedroom apartments, and 4-bedroom duplexes with modern amenities and stunning city views.',
  ellingtonPricing: {
    startingPrice: {
      aed: 1150828
    },
    paymentPlan: '70/30 Payment Plan (20% Down)',
    highlights: 'Wellness-focused design in JLT'
  },
  specialFeatures: [
    'Starting from AED 1.15M',
    '70/30 Payment Plan',
    '20% Down Payment',
    '325 total residences',
    '2 linked towers',
    'Studios to 4BR duplexes',
    'Wellness-focused design',
    'Handover July 2027'
  ],
  features: [
    { icon: 'FaCity', text: 'City Views' },
    { icon: 'FaSwimmingPool', text: 'Wellness Pool' },
    { icon: 'FaDumbbell', text: 'Premium Fitness Center' },
    { icon: 'FaSpa', text: 'Spa & Wellness' },
    { icon: 'FaCar', text: 'Covered Parking' },
    { icon: 'FaShieldAlt', text: 'Concierge & Security' },
    { icon: 'FaBuilding', text: 'Modern Architecture' },
    { icon: 'FaChild', text: 'Family Amenities' }
  ],
  contact: {
    name: 'Sales Team',
    position: 'Property Consultant',
    company: 'Ellington Properties',
    phone: '+971XXXXXXXXX',
    email: 'sales@ellington.ae'
  },
  media: [
    {
      type: 'video',
      src: '/assets/residential/ellington/mercer-house-video.mp4',
      poster: '/assets/residential/ellington/mercer-house.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/mercer-house.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/mercer-house-1.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/mercer-house-2.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/mercer-house-3.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/mercer-house-4.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/mercer-house-5.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/mercer-house-6.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/mercer-house-7.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/mercer-house-8.jpg'
    }
  ]
},

'portside-square-mina-rashid': {
  title: 'Portside Square',
  location: 'Mina Rashid, Dubai, UAE',
  type: 'Studios to 4BR Waterfront Apartments',
  builder: 'Ellington Properties',
  floors: '3 Towers | G+P+R+16',
  category: 'Residential',
  bedrooms: 'Studio-4 BR',
  bathrooms: '1-4',
  area: '408 Apartments',
  isFeatured: false,
  description: 'Portside Square offers waterfront living in the historic port district of Mina Rashid with 408 apartments across three mid-rise towers. Experience marina promenade living with studios, 1-4 bedroom residences, and penthouses.',
  ellingtonPricing: {
    startingPrice: {
      aed: 1148000
    },
    paymentPlan: '70/30 Payment Plan (20% Down)',
    highlights: 'Marina promenade & historic port district'
  },
  specialFeatures: [
    'Starting from AED 1.15M',
    '70/30 Payment Plan',
    '20% Down Payment',
    '408 total apartments',
    '3 mid-rise towers',
    'Studios to 4BR & penthouses',
    'Marina promenade access',
    'Handover Q4 2029'
  ],
  features: [
    { icon: 'FaCity', text: 'Marina Views' },
    { icon: 'FaSwimmingPool', text: 'Waterfront Pool' },
    { icon: 'FaDumbbell', text: 'Fitness Center' },
    { icon: 'FaCar', text: 'Covered Parking' },
    { icon: 'FaShieldAlt', text: '24/7 Security' },
    { icon: 'FaBuilding', text: 'Modern Design' },
    { icon: 'FaChild', text: 'Kids Play Area' },
    { icon: 'FaUtensils', text: 'Marina Dining' }
  ],
  contact: {
    name: 'Sales Team',
    position: 'Property Consultant',
    company: 'Ellington Properties',
    phone: '+971XXXXXXXXX',
    email: 'sales@ellington.ae'
  },
  media: [
    {
      type: 'video',
      src: '/assets/residential/ellington/portside-square-video.mp4',
      poster: '/assets/residential/ellington/portside-square.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/portside-square.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/portside-square-1.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/portside-square-2.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/portside-square-3.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/portside-square-4.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/portside-square-5.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/portside-square-6.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/portside-square-7.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/portside-square-8.jpg'
    }
  ]
},

'the-quayside-business-bay': {
  title: 'The Quayside',
  location: 'Business Bay, Dubai, UAE',
  type: 'Studios to 3BR Waterfront Apartments',
  builder: 'Ellington Properties',
  floors: 'High-Rise',
  category: 'Residential',
  bedrooms: 'Studio-3 BR',
  bathrooms: '1-3',
  area: 'Studios to 3BR Apartments',
  isFeatured: false,
  description: 'The Quayside offers premium waterfront living in Business Bay with stunning canal views near Burj Khalifa. Featuring studios to 3-bedroom apartments with world-class amenities.',
  ellingtonPricing: {
    startingPrice: {
      aed: 1315828
    },
    paymentPlan: '70/30 Payment Plan (20% Down)',
    highlights: 'Canal views near Burj Khalifa'
  },
  specialFeatures: [
    'Starting from AED 1.32M',
    '70/30 Payment Plan',
    '20% Down Payment',
    'Studios to 3BR apartments',
    'Canal views',
    'Near Burj Khalifa',
    'Business Bay location',
    'Handover Q1 2026'
  ],
  features: [
    { icon: 'FaCity', text: 'Canal & City Views' },
    { icon: 'FaBuilding', text: 'Near Burj Khalifa' },
    { icon: 'FaSwimmingPool', text: 'Infinity Pool' },
    { icon: 'FaDumbbell', text: 'Modern Gym' },
    { icon: 'FaCar', text: 'Covered Parking' },
    { icon: 'FaShieldAlt', text: 'Concierge Services' },
    { icon: 'FaSpa', text: 'Wellness Facilities' },
    { icon: 'FaUtensils', text: 'Waterfront Dining' }
  ],
  contact: {
    name: 'Sales Team',
    position: 'Property Consultant',
    company: 'Ellington Properties',
    phone: '+971XXXXXXXXX',
    email: 'sales@ellington.ae'
  },
  media: [
    {
      type: 'video',
      src: '/assets/residential/ellington/the-quayside-video.mp4',
      poster: '/assets/residential/ellington/the-quayside.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/the-quayside.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/the-quayside-1.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/the-quayside-2.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/the-quayside-3.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/the-quayside-4.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/the-quayside-5.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/the-quayside-6.jpg'
    }
  ]
},

'amaal-8-south-tower': {
  title: 'AMAAL 8 - South Tower',
  location: 'Meydan Horizon, MBR City, Dubai, UAE',
  type: '1-4BR Apartments & Duplexes',
  builder: 'Amaal Properties',
  floors: '55-Storey Twin Towers',
  category: 'Residential',
  bedrooms: '1-4 BR',
  bathrooms: '1-4',
  area: '512 Residences',
  isFeatured: false,
  description: 'AMAAL 8 South Tower offers modern living in Meydan Horizon with panoramic views of Dubai Creek, Crystal Lagoon, and Downtown Dubai. Features 55 floors with 1-4 bedroom apartments, duplexes, and the elite Infinity Collection.',
  ellingtonPricing: {
    startingPrice: {
      aed: 1600000
    },
    paymentPlan: '50/50 Payment Plan (10% Down)',
    highlights: 'Crystal Lagoon & Downtown views'
  },
  specialFeatures: [
    'Starting from AED 1.6M',
    '50/50 Payment Plan',
    '10% Down Payment',
    '55-storey towers',
    'Crystal lagoon views',
    'Downtown Dubai views',
    'Infinity Collection available',
    'Handover Q4 2028'
  ],
  features: [
    { icon: 'FaCity', text: 'Panoramic Views' },
    { icon: 'FaSwimmingPool', text: 'Infinity & Lap Pools' },
    { icon: 'FaDumbbell', text: 'Wellness Gym' },
    { icon: 'FaCar', text: 'VIP Parking' },
    { icon: 'FaShieldAlt', text: '24/7 Security' },
    { icon: 'FaChild', text: 'Kids Pool & Play Area' },
    { icon: 'FaSpa', text: 'Spa & Wellness' },
    { icon: 'FaBuilding', text: '49th Floor Observation Deck' }
  ],
  contact: {
    name: 'Sales Team',
    position: 'Property Consultant',
    company: 'Amaal Properties',
    phone: '+971XXXXXXXXX',
    email: 'sales@amaalproperties.com'
  },
  media: [
    {
      type: 'video',
      src: '/assets/residential/amaal/amaal-8-south-video.mp4',
      poster: '/assets/residential/amaal/amaal-8-south.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/amaal/amaal-8-south.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/amaal/amaal-8-south-1.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/amaal/amaal-8-south-2.jpg'
    }
  ]
},

'mansory-residences-north-tower': {
  title: 'MANSORY Residences - North Tower',
  location: 'Meydan Horizon, MBR City, Dubai, UAE',
  type: '1-4BR Branded Apartments & Duplexes',
  builder: 'Amaal Properties & MANSORY',
  floors: '55-Storey Luxury Tower',
  category: 'Residential',
  bedrooms: '1-4 BR',
  bathrooms: '1-5',
  area: 'Branded Residences',
  isFeatured: true,
  isLuxury: true,
  description: 'MANSORY Residences North Tower brings ultra-luxury branded living to Meydan Horizon. Exclusively branded by MANSORY, featuring automotive-inspired design, premium finishes, and spectacular full-floor Infinity penthouses.',
  ellingtonPricing: {
    startingPrice: {
      aed: 2100000
    },
    paymentPlan: '50/50 Payment Plan (10% Down)',
    highlights: 'MANSORY branded luxury residences'
  },
  specialFeatures: [
    'Starting from AED 2.1M',
    '50/50 Payment Plan',
    '10% Down Payment',
    'MANSORY branded residence',
    'Automotive-inspired design',
    '1-4BR apartments & duplexes',
    'Full-floor Infinity penthouses',
    'Handover Q4 2028'
  ],
  features: [
    { icon: 'FaCrown', text: 'MANSORY Branded' },
    { icon: 'FaCity', text: 'Skyline Views' },
    { icon: 'FaSwimmingPool', text: 'Infinity Pool' },
    { icon: 'FaDumbbell', text: 'Premium Gym' },
    { icon: 'FaSpa', text: 'Luxury Spa' },
    { icon: 'FaCar', text: 'Valet Parking' },
    { icon: 'FaShieldAlt', text: 'Concierge Services' },
    { icon: 'FaUtensils', text: 'Fine Dining' },
    { icon: 'FaBuilding', text: 'Sky Deck & Lounges' }
  ],
  contact: {
    name: 'Luxury Sales Team',
    position: 'Senior Property Consultant',
    company: 'Amaal Properties',
    phone: '+971XXXXXXXXX',
    email: 'luxury@amaalproperties.com'
  },
  images: [
    '/assets/residential/mansory/mansory-north.jpg',
    '/assets/residential/mansory/mansory-north-1.jpg',
    '/assets/residential/mansory/mansory-north-2.jpg',
    '/assets/residential/mansory/mansory-north-3.jpg'
  ]
},

'v-suites-business-bay': {
  title: 'V-Suites',
  location: 'Business Bay, Dubai, UAE',
  type: 'Studios to 3BR Apartments',
  builder: 'ANAX Developments',
  floors: 'G+P+3+19 Floors (23 Storeys)',
  category: 'Residential',
  bedrooms: 'Studio-3 BR',
  bathrooms: '1-3',
  area: '225 Residences',
  isFeatured: false,
  mapUrl: 'https://maps.google.com/?q=V+Suites+Business+Bay+Dubai',
  description: 'V-Suites offers fully furnished studios to 3-bedroom apartments in the heart of Business Bay with premium Venetian Enrico interiors. Features a 5-year post-handover payment plan, making it perfect for investors and end-users seeking luxury living.',
  ellingtonPricing: {
    startingPrice: {
      aed: 1620000
    },
    paymentPlan: '30/20/50 Payment Plan',
    highlights: 'Fully furnished by Venetian Enrico'
  },
  specialFeatures: [
    'Starting from AED 1.62M',
    '30/20/50 Payment Plan',
    '20% BCC + 50% over 5 years',
    'Fully furnished by Venetian Enrico',
    '225 total residences',
    '23-storey tower',
    'Business Bay prime location',
    'Handover Q4 2026'
  ],
  features: [
    { icon: 'FaSwimmingPool', text: 'Rooftop Pool' },
    { icon: 'FaDumbbell', text: 'Modern Fitness Center' },
    { icon: 'FaCar', text: 'Covered Parking' },
    { icon: 'FaShieldAlt', text: '24/7 Security' },
    { icon: 'FaBuilding', text: 'Business Bay Location' },
    { icon: 'FaStar', text: 'Fully Furnished Units' },
    { icon: 'FaCity', text: 'City Views' },
    { icon: 'FaCouch', text: 'Smart Home Features' }
  ],
  contact: {
    name: 'Property Sales Team',
    position: 'Property Consultant',
    company: 'ANAX Developments',
    phone: '+971XXXXXXXXX',
    email: 'sales@anaxdevelopments.ae'
  },
  media: [
    {
      type: 'video',
      src: '/assets/residential/ellington/v-suites-video.mp4',
      poster: '/assets/residential/ellington/v-suites.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/v-suites.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/v-suites-1.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/v-suites-2.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/v-suites-3.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/v-suites-4.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/v-suites-5.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/v-suites-6.jpg'
    }
  ]
},

'azizi-road-dubai': {
  title: 'Azizi Road (Azizi Riviera 65)',
  location: 'Meydan, MBR City, Dubai, UAE',
  type: 'Studios & 1-2BR Apartments',
  builder: 'Azizi Developments',
  floors: 'Mid-Rise (4 Buildings)',
  category: 'Residential',
  bedrooms: 'Studio-2 BR',
  bathrooms: '1-2',
  area: 'Multiple Units',
  isFeatured: false,
  mapUrl: 'https://maps.google.com/?q=Azizi+Riviera+Meydan+MBR+City+Dubai',
  description: 'Azizi Riviera 65 offers affordable waterfront-inspired living in Meydan, MBR City with contemporary studios and 1-2 bedroom apartments. Featuring crystal lagoon access, private beaches, and world-class connectivity.',
  ellingtonPricing: {
    startingPrice: {
      aed: 607000
    },
    paymentPlan: '40/60 Payment Plan',
    highlights: 'Crystal lagoon & beach access'
  },
  specialFeatures: [
    'Studio: Starting from AED 607K',
    '1 BR: Starting from AED 924K',
    '40/60 Payment Plan',
    'Crystal lagoon access',
    'Sandy beaches',
    'MBR City location',
    'Retail and dining outlets',
    'Handover Q3 2027'
  ],
  features: [
    { icon: 'FaSwimmingPool', text: 'Crystal Lagoons' },
    { icon: 'FaDumbbell', text: 'Fitness Center' },
    { icon: 'FaUmbrellaBeach', text: 'Sandy Beaches' },
    { icon: 'FaUtensils', text: 'Restaurants & Cafes' },
    { icon: 'FaCar', text: 'Covered Parking' },
    { icon: 'FaShieldAlt', text: '24/7 Security' },
    { icon: 'FaChild', text: 'Children\'s Play Area' },
    { icon: 'FaShoppingBag', text: 'Retail Boulevard' }
  ],
  contact: {
    name: 'Sales Team',
    position: 'Senior Property Consultant',
    company: 'Azizi Developments',
    phone: '+971XXXXXXXXX',
    email: 'sales@azizidevelopments.ae'
  },
  media: [
    {
      type: 'video',
      src: '/assets/residential/azizi/azizi-road-video.mp4',
      poster: '/assets/residential/ellington/azizi-road.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/azizi-road.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/azizi/azizi-road-1.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/azizi/azizi-road-2.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/azizi/azizi-road-3.jpg'
    }
  ]
},

'taj-wellington-mews-al-marjan': {
  title: 'Taj Wellington Mews',
  location: 'Al Marjan Island, Ras Al Khaimah, UAE',
  type: 'Studios to 3BR Luxury Apartments',
  builder: 'BNW Developments',
  floors: '2 Twin Towers',
  category: 'Residential',
  bedrooms: 'Studio-3 BR',
  bathrooms: '1-3',
  area: '342 Ultra Luxury Units',
  isFeatured: false,
  mapUrl: 'https://maps.google.com/?q=Taj+Wellington+Mews+Al+Marjan',
  description: 'Taj Wellington Mews presents elegant studios to 3-bedroom luxury apartments with premium finishes and world-class amenities on Al Marjan Island. Experience sophisticated island living near luxury resorts with unparalleled sea views.',
  ellingtonPricing: {
    startingPrice: {
      aed: 3162613
    },
    paymentPlan: 'Flexible Payment Plans',
    highlights: 'Luxury living with exceptional amenities'
  },
  specialFeatures: [
    'Starting from AED 3.16M',
    '342 ultra-luxury units',
    '2 twin towers',
    'Studios to 3BR apartments',
    'Al Marjan Island location',
    'Near luxury resorts & Wynn Casino',
    'Premium finishes',
    'Handover Q4 2027'
  ],
  features: [
    { icon: 'FaSwimmingPool', text: 'Infinity Pool' },
    { icon: 'FaDumbbell', text: 'State-of-art Gym' },
    { icon: 'FaSpa', text: 'Spa & Wellness' },
    { icon: 'FaUmbrellaBeach', text: 'Beach Access' },
    { icon: 'FaCar', text: 'Valet Parking' },
    { icon: 'FaShieldAlt', text: 'Concierge Service' },
    { icon: 'FaBuilding', text: 'Twin Towers' },
    { icon: 'FaUtensils', text: 'Fine Dining' }
  ],
  contact: {
    name: 'Luxury Sales Team',
    position: 'Luxury Property Specialist',
    company: 'BNW Developments',
    phone: '+971XXXXXXXXX',
    email: 'luxury@bnwdevelopments.com'
  },
  media: [
    {
      type: 'video',
      src: '/assets/residential/ellington/taj-wellington-video.mp4',
      poster: '/assets/residential/ellington/taj-wellington.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/taj-wellington.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/taj-wellington-1.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/taj-wellington-2.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/taj-wellington-3.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/taj-wellington-4.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/taj-wellington-5.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/taj-wellington-6.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/taj-wellington-7.jpg'
    },
    {
      type: 'image',
      src: '/assets/residential/ellington/taj-wellington-8.jpg'
    }
  ]
},

'ramada-residences-al-jaddaf': {
  title: 'Ramada Residences by Wyndham',
  location: 'Al Jaddaf, Dubai, UAE',
  type: '1 & 2BR Branded Apartments',
  builder: 'BNW Developments & Wyndham',
  floors: 'High-Rise',
  category: 'Residential',
  bedrooms: '1-2 BR',
  bathrooms: '1-2',
  area: 'Multiple Units',
  isFeatured: true,
  mapUrl: 'https://maps.google.com/?q=Ramada+Residence+Al+Jaddaf+Dubai',
  description: 'Ramada Residences by Wyndham Al Jaddaf offers fully furnished one and two-bedroom serviced apartments with hotel-style amenities. Perfect for both short and long-term stays with 5-star concierge services and guaranteed rental returns.',
  ellingtonPricing: {
    startingPrice: {
      aed: 1750000
    },
    paymentPlan: 'Mortgage Available',
    highlights: '5-star concierge & hotel-style services'
  },
  specialFeatures: [
    'Starting from AED 1.75M',
    '1-2 bedroom apartments',
    'Fully furnished apartments',
    'Wyndham hotel-managed property',
    'Guaranteed rental returns',
    'Close to Dubai Creek',
    'Easy access to Downtown Dubai',
    'Handover Q2 2026'
  ],
  features: [
    { icon: 'FaSwimmingPool', text: 'Rooftop Pool' },
    { icon: 'FaDumbbell', text: 'Fitness Center' },
    { icon: 'FaUtensils', text: 'Restaurant' },
    { icon: 'FaCar', text: 'Parking' },
    { icon: 'FaShieldAlt', text: 'Hotel Security' },
    { icon: 'FaBuilding', text: 'Business Lounge' },
    { icon: 'FaStar', text: 'Concierge Services' },
    { icon: 'FaCouch', text: 'Fully Furnished' }
  ],
  contact: {
    name: 'Investment Team',
    position: 'Investment Advisor',
    company: 'BNW Developments',
    phone: '+971XXXXXXXXX',
    email: 'ramada@bnwdevelopments.com'
  },
  images: [
    '/assets/residential/ellington/al-jaddaf.jpg',
    '/assets/residential/ellington/al-jaddaf-1.jpg',
    '/assets/residential/ellington/al-jaddaf-2.jpg',
    '/assets/residential/ellington/al-jaddaf-3.jpg',
    '/assets/residential/ellington/al-jaddaf-4.jpg',
    '/assets/residential/ellington/al-jaddaf-5.jpg',
    '/assets/residential/ellington/al-jaddaf-6.jpg'
  ]
},

'pelagia-al-marjan': {
  title: 'Pelagia',
  location: 'Al Marjan Island, Ras Al Khaimah, UAE',
  type: '1-4BR Waterfront Apartments',
  builder: 'BNW Developments',
  floors: 'Waterfront Complex',
  category: 'Residential',
  bedrooms: '1-4 BR',
  bathrooms: '1-4',
  area: 'Multiple Units',
  isFeatured: true,
  isLuxury: false,
  mapUrl: 'https://maps.google.com/?q=Pelagia+Al+Marjan+Island',
  description: 'Pelagia offers an exquisite range of 1 to 4-bedroom waterfront apartments on Al Marjan Island with premium finishes, smart home automation, and private beach access. Perfect for families and professionals seeking sophisticated beachfront living.',
  ellingtonPricing: {
    startingPrice: {
      aed: 2300000
    },
    paymentPlan: 'Flexible Payment Plans',
    highlights: 'Private beach & smart home automation'
  },
  specialFeatures: [
    'Starting from AED 2.3M',
    '1-4 bedroom & penthouses',
    'Private beach access',
    'Smart home automation',
    'Waterfront location',
    'Premium quality finishes',
    'Family-friendly community',
    'Handover December 2027'
  ],
  features: [
    { icon: 'FaSwimmingPool', text: 'Swimming Pools' },
    { icon: 'FaDumbbell', text: 'Fully Equipped Gym' },
    { icon: 'FaChild', text: 'Kids Play Area' },
    { icon: 'FaSpa', text: 'Spa Facilities' },
    { icon: 'FaUmbrellaBeach', text: 'Private Beach' },
    { icon: 'FaCar', text: 'Covered Parking' },
    { icon: 'FaShieldAlt', text: '24/7 Security' },
    { icon: 'FaBuilding', text: 'Smart Home Systems' }
  ],
  contact: {
    name: 'Sales Team',
    position: 'Property Consultant',
    company: 'BNW Developments',
    phone: '+971XXXXXXXXX',
    email: 'sales@bnwdevelopments.com'
  },
  images: [
    '/assets/residential/ellington/pelagia.jpg',
    '/assets/residential/ellington/pelagia-1.jpg',
    '/assets/residential/ellington/pelagia-2.jpg',
    '/assets/residential/ellington/pelagia-3.jpg',
    '/assets/residential/ellington/pelagia-4.jpg',
    '/assets/residential/ellington/pelagia-5.jpg',
    '/assets/residential/ellington/pelagia-6.jpg'
  ]
},

'la-perla-al-marjan': {
  title: 'La Perla',
  location: 'Al Marjan Island, Ras Al Khaimah, UAE',
  type: '1-3BR Luxury Apartments & Duplexes',
  builder: 'BNW Developments',
  floors: '2B+G+6F+R',
  category: 'Residential',
  bedrooms: '1-3 BR',
  bathrooms: '1-3',
  area: '226 Luxury Units',
  isFeatured: true,
  isLuxury: true,
  mapUrl: 'https://maps.google.com/?q=La+Perla+Al+Marjan+Island',
  description: 'La Perla is a distinguished residential development offering 226 luxury apartments with 1 to 3-bedroom configurations on Al Marjan Island. Experience refined Italian-inspired architecture with Spanish courtyard design and rooftop infinity pool.',
  ellingtonPricing: {
    startingPrice: {
      aed: 2160000
    },
    paymentPlan: '50/50 Payment Plan (10% Down)',
    highlights: 'Spanish courtyard & rooftop infinity pool'
  },
  specialFeatures: [
    'Starting from AED 2.16M',
    '226 luxury units',
    '50/50 Payment Plan',
    '10% Down Payment',
    'Italian-inspired design',
    'Spanish courtyard',
    'Rooftop infinity pool',
    'Handover Q4 2027'
  ],
  features: [
    { icon: 'FaSwimmingPool', text: 'Rooftop Infinity Pool' },
    { icon: 'FaDumbbell', text: 'Fitness Center' },
    { icon: 'FaSpa', text: 'Wellness Center' },
    { icon: 'FaUmbrellaBeach', text: 'Beach Access' },
    { icon: 'FaCar', text: 'Private Parking' },
    { icon: 'FaShieldAlt', text: 'Gated Community' },
    { icon: 'FaBuilding', text: 'Spanish Architecture' },
    { icon: 'FaChild', text: 'Play Areas' }
  ],
  contact: {
    name: 'Luxury Sales Team',
    position: 'Senior Consultant',
    company: 'BNW Developments',
    phone: '+971XXXXXXXXX',
    email: 'luxury@bnwdevelopments.com'
  },
  images: [
    '/assets/residential/ellington/la-perla.jpg',
    '/assets/residential/la-perla/la-perla-1.jpg',
    '/assets/residential/la-perla/la-perla-2.jpg',
    '/assets/residential/la-perla/la-perla-3.jpg'
  ]
},

'fashion-tv-acacia-al-marjan': {
  title: 'Fashion TV Acacia',
  location: 'Al Marjan Island, Ras Al Khaimah, UAE',
  type: '1-3BR & 4BR Penthouses',
  builder: 'BNW Developments',
  floors: 'Ground + 1-2-3-4-5-6 Floors',
  category: 'Residential',
  bedrooms: '1-4 BR',
  bathrooms: '1-4',
  area: '229 Branded Units',
  isFeatured: true,
  mapUrl: 'https://maps.google.com/?q=Fashion+TV+Acacia+Al+Marjan',
  description: 'Fashion TV Acacia brings the glamour of the fashion world to beachfront living on Al Marjan Island. Featuring 229 stylish branded units with 1 to 3-bedroom apartments and 4-bedroom penthouses, offering exclusive Fashion TV lifestyle amenities.',
  ellingtonPricing: {
    startingPrice: {
      aed: 2000000
    },
    paymentPlan: 'Flexible Payment Plans',
    highlights: 'Couture-inspired beachfront living'
  },
  specialFeatures: [
    'Starting from AED 2M',
    '229 branded units',
    'Fashion TV branded residence',
    'Ground to 6th floor options',
    '1-3BR & 4BR penthouses',
    'Glamorous interiors',
    'Exclusive lifestyle amenities',
    'Handover Q2 2028'
  ],
  features: [
    { icon: 'FaSwimmingPool', text: 'Designer Pool' },
    { icon: 'FaDumbbell', text: 'Fashion TV Gym' },
    { icon: 'FaSpa', text: 'Beauty & Spa' },
    { icon: 'FaUmbrellaBeach', text: 'Beachfront Access' },
    { icon: 'FaCar', text: 'Valet Parking' },
    { icon: 'FaShieldAlt', text: 'Premium Security' },
    { icon: 'FaStar', text: 'Fashion TV Lounge' },
    { icon: 'FaBuilding', text: 'Branded Interiors' }
  ],
  contact: {
    name: 'Fashion TV Sales Team',
    position: 'Luxury Brand Specialist',
    company: 'BNW Developments',
    phone: '+971XXXXXXXXX',
    email: 'fashiontv@bnwdevelopments.com'
  },
  images: [
    '/assets/residential/ellington/fashion-tv-acacia.jpg',
    '/assets/residential/ellington/acacia-1.jpg',
    '/assets/residential/ellington/acacia-2.jpg',
    '/assets/residential/ellington/acacia-3.jpg',
    '/assets/residential/ellington/acacia-4.jpg',
    '/assets/residential/ellington/acacia-5.jpg',
    '/assets/residential/ellington/acacia-6.jpg',
    '/assets/residential/ellington/acacia-7.jpg'
  ]
},

'aqua-arc-al-marjan': {
  title: 'Aqua Arc',
  location: 'Al Marjan Island, Ras Al Khaimah, UAE',
  type: '1-3BR Waterfront Apartments',
  builder: 'BNW Developments',
  floors: '12-Floor Tower',
  category: 'Residential',
  bedrooms: '1-3 BR',
  bathrooms: '1-3',
  area: 'Multiple Units',
  isFeatured: false,
  mapUrl: 'https://maps.google.com/?q=Aqua+Arc+Al+Marjan+Island',
  description: 'Aqua Arc is a stunning 12-floor waterfront development offering 1 to 3-bedroom apartments with breathtaking water views on Al Marjan Island. Experience sustainable architecture blended with modern curved design, private beach access, and premium amenities.',
  ellingtonPricing: {
    startingPrice: {
      aed: 2500000
    },
    paymentPlan: 'Flexible Payment Schemes',
    highlights: 'Sustainable architecture & private beach'
  },
  specialFeatures: [
    'Starting from AED 2.5M',
    '12-floor tower',
    'Waterfront location',
    'Panoramic water views',
    '1 to 3-bedroom apartments',
    'Modern curved architecture',
    'Sustainable design',
    'Handover Q4 2027'
  ],
  features: [
    { icon: 'FaSwimmingPool', text: 'Infinity Pool' },
    { icon: 'FaDumbbell', text: 'Sky Gym' },
    { icon: 'FaUmbrellaBeach', text: 'Private Beach' },
    { icon: 'FaSpa', text: 'Wellness Center' },
    { icon: 'FaCar', text: 'Basement Parking' },
    { icon: 'FaShieldAlt', text: 'Smart Security' },
    { icon: 'FaChild', text: 'Kids Pool' },
    { icon: 'FaBuilding', text: 'Observation Deck' }
  ],
  contact: {
    name: 'Waterfront Sales Team',
    position: 'Waterfront Specialist',
    company: 'BNW Developments',
    phone: '+971XXXXXXXXX',
    email: 'waterfront@bnwdevelopments.com'
  },
  images: [
    '/assets/residential/ellington/aqua-arc.jpg',
    '/assets/residential/ellington/aqua-arc-1.jpg',
    '/assets/residential/ellington/aqua-arc-2.jpg',
    '/assets/residential/ellington/aqua-arc-3.jpg',
    '/assets/residential/ellington/aqua-arc-4.jpg',
    '/assets/residential/ellington/aqua-arc-5.jpg',
    '/assets/residential/ellington/aqua-arc-6.jpg',
    '/assets/residential/ellington/aqua-arc-7.jpg',
    '/assets/residential/ellington/aqua-arc-8.jpg',
    '/assets/residential/ellington/aqua-arc-9.jpg',
    '/assets/residential/ellington/aqua-arc-10.jpg'
  ]
}
};
// Exchange rates (as of February 2026)
export const exchangeRates = {
  AED_TO_AUD: 0.407,
  AED_TO_INR: 24.56,
  AED_TO_USD: 0.272
};
